import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n

  .use(LanguageDetector)

  .use(initReactI18next)

  .init({
    debug: true,
    fallbackLng: "English",
    interpolation: {
      escapeValue: false,
    },
    resources: {
      English: {
        translation: {
          header: {
            security2Fa: {
              security2FA: "Security-2FA",
              download: "Download and install ",
              downloadLink: "Google Authenticator.",
              downloadParaLeft:
                " Enable Two-factor Authentication to protect your account from unauthorized access.",
              scanQr:
                "Scan the QR code with your Google Authenticator App or enter the secret key manually.",
              verificationCode: "Verification code",
              yourSecretKey: "Your Secret Key",
              enable2Fa: "Enable 2FA",
              disable2Fa: "Disable 2FA",
              para: "Write down this code, never reveal it to others. You can use it to regain access to your account if there is no access to the authenticator.",
            },
            banner: {
              refruend: "Refer Friends to Earn ",
              comision: "15% COMMISSION ",
              earn: "Sign up & Earn",
              term: "Referral Terms & Conditions ",
              reward: "Get your Referrals Rewards ",
              detail:
                "Every friend you invite, Will get you money, the more you invite, the more you will get!",
              rewardinpersent: "Get your 15% Commission Rewards ",
              resivedreward:
                "You will receive commission rewards every time your friends place wager based on the games. ",
              dashbord: "Go to Dashboard ",
            },
            question: {
              qone: "How does the referral system work?",
              ansone:
                "When you share your referral link with any of your friends, family, or advertise, someone signs up to play at BCW.CLUB, that player becomes your referral and will earn you commissions and extra benefits.",
              qtwo: "How much can I earn for referring a friend?",
              anstwo: "Per referral, you can earn 15% * 1% of their wager.",
              qthre: "Can I view my referral's data?",
              ansthre:
                "Yes, BCW.CLUB believes in complete transparency and provides all user information, including username, Play placed and commission earned. Everything is in your affiliate dashboard.",
              qfour: "How can I track the number of players I have referred?",
              ansfour:
                "You can view your earnings and other statistics through the affiliate program's dashboard.",
              qfive: "What are the payment options available for affiliates?",
              ansfive:
                "The rewards you earn are in the form of BCW, our official game coin. BCW coin is swappable with any supported crypto-currency on the platform. Once you earn some money through referrals, you can add it to your wallet from the affiliate dashboard.",
              qsix: "What kind of customer support is available for players of the BCW.club?",
              anssix:
                "BCW.CLUB has a dedicated customer support team available to help players with any questions or issues they may have. As an affiliate, it's important to promote a high-quality, trustworthy online gaming that offers excellent customer support.",
              qseven: "What is the minimum payout threshold?",
              ansseven:
                "The minimum payout threshold is the minimum amount of commission you must earn before you can request a payout. In BCW.CLUB there is no minimum threshold; you can claim your earnings anytime.",
            },
            signin: {
              signin: "Sign in",
              email: "Email",
              loginPassword: "Password",
              forgotPass: "Forgot password",
              directSignin: "Or sign up directly with",
              resetPass: "Reset password ",
              enteremail: "Enter Email",
              enterpassword: "Enter password",
              emailaddress: "Email Adress",
              haveAccount: "Alredy have an account?",
              register:"Registered Email Address",
              
            },
            signup: {
              signup: "Signup",
              daily:"DAILY",
              win:"WIN",
              spinthewheel:"Spin the Wheel",
              winfreecrypto:"WIN FREE CRYPTO!",
              email: "Email Address",
              enterpassword: "Enter Password",
              password: "Password",
              agreement:
                "I agree with user agreement, and confirm that I am at least 18 years old!",
              directSignup: "Or sign up directly with",
              editProfile: "Edit Profile",
              referralcode: "Referral code",
              referral: "Referral",
              enterrefcode: "enter your referral code",
              passwordrequired: "Password is required",
            },
            chat: {
              chat: "Chat",
              global: "Global",
              chatRules: "Chat Rules",
              message: "You Message",
              rule1:
                "Don't spam, harass or be offensive to other users. Also, avoid using CAPS! No one likes to be screamed at!",
              rule2:
                "Don't beg or ask for loans, rains, tips and doubling coins.",
              rule3:
                "No suspicious behavior that can be seen as potential scams.",
              rule4:
                "Don't engage in any forms of advertising/ trading/ selling/ buying or offering services.",
              rule5:
                "Don't use URL shortener. Always submit the original link.",
              rule6: "Use the designated language chatrooms accordingly.",
            },
            referral: {
              spin: "Spin",
              menu: "Menu",
              ern: "Earn",
              crypto: "Crypto",
              fiat: "Fiat",
              hidempty: "Hide Empty",
              search: "Search",
              chtroom: "Chat Room",
              dashbord: " Go To Dashboard",
              question: "Frequently Asked Questions",
              Affiliate: "Affiliate",
             cardnumber:"Card Number / Account Number",
              vip:"My VIP Perks",
              trans:"Transactions",
              earn:"Spin & Earn",
              stat:"Statistics",
              bcs:"BCSwap",
              tot:"Total",
              alplyer:"all players",
              userinfo:"User Information",
              free:"Next Free",
              rerearn:"Refer and Earn",

              Crash: " crash",
              Casino: "Original Games",
              Logout: "Logout",
              Casno: "Original Games",
              BCWOriginals: " BCW Originals",
              Crash: "Crash",
              Promo: "Promotions",
              TotalEarned: "Total Reward Earned",
              TotalFrReferred: "Total Friends Referred:",
              Referfriend: "Refer a friend",
              userId: "User Id",
              username: "User Name",
              totacommission: "Tota Commission",
              totalwager: "Total Wager",
              shareyourreferralink: "Share your referral link",
              claimed: "Claimed ",
              update: "Update",
              referralmanagement: "Referral Management",
              totalFriendsreferred: "Total Friends Referred:",
              claimnow: "Claim Now",
              oop: "Oops ! There is no data yet.",
              bankroll: " Bankroll",
              Notclaimed: "Not Claimed",
              mores: "More",
              notes: "Notice",
              alplyer: "all players",
              fee: "Fee",
              invalidAmount: "Invalid Amount",
              currencynotavailable:"Currency Not Available, Please choose other",
            },
            span: {
              wheel: "Prize Wheel ",
              spannow: "Spin Now",
            },
            wallet: {
              name: "Name",
              wallet: "Wallet",
              deposit: "Deposit",
              buy: "Buy",
              toppay: "Toppay",
              confirm: "Confirm",
              maxamount:"Maximum amount should be",
              minamount:"Minumum amount should be",
              safty:
                "Redirecting to deposit page, Supported by BCW .Club official and trusted providers. ",
              safety: "For any questions, contact our 24hrs Live Support ",
              metod: "Choose a Payment Method",
              bankdeposit: "Fiat Deposit - Bank Transfer",
              bankwithdraw: "Fiat Withdraw - Bank Transfer",
              accountholder: "Account Holder",
              bankname: "Bank Name",
              crypto: "Crypto",
              bankaccount: "Bank Account",
              idcard: "ID Card",
              phone: "Phone",
              vault: "Vault",
              swap: "Swap",
              withdraw: "Withdraw",
              transaction: "Transactions",
              secureAsset: "To secure your assets,",
              please: "please",
              enableFa: "Enable 2FA",
              disableFa: "Disable 2Fa",
              mostpara:
                "The most exciting part of plating at a Crypto gaming is the bonuses on offer! BCW.CLUB, the leading Crypto gaming platform in the world offers you, our loyal players, not 1 but 4 rewarding deposit bonuses.",
              mostparaone:
                "The best part about having 4 bonuses is that you can enjoy Crypto online gaming with some help from the friendliest and most rewarding gaming platform  out there! There is no deposit bonus like that of BCW.CLUB with a whopping total of 1050% deposit match",
              notonly:
                "Not only is this the perfect time to make extra Crypto but it is your opportunity to get hold of some of our very own Crypto coins, BCW coin (BCW) You will be rewarded with BCW for your deposits to use at your discretion.",
              fristdeposit: "1st Deposit Bonus",
              secondbon: "2nd Deposit Bonus:",
              thirdbon: "3rd Deposit Bonus:",
              fourthbon: "4th Deposit Bonus:",
              fristbonce:
                "Welcome to BCW.CLUB, the premier destination for all your Crypto BCW.Clubneeds! We're excited to offer you a huge 250% deposit match, up to 20,000BCW, when you make your first deposit today. This is your chance to maximize your gaming experience and win big. Don't miss out on this incredible opportunity! With a minimum recharge amount of just 30 USD, you can start playing and earning BCW in no time. So what are you waiting for? Play now and start winning!",
              seconddep:
                "Congratulations! You've taken the first step towards an epic Crypto BCW.Clubjourney. And we're thrilled to reward your loyalty with a spectacular 250% deposit match, up to 40,000BCW, on your second deposit. At BCW.CLUB, we believe in delivering nothing but the best to our players. And this bonus is no exception. With a minimum recharge amount of 60 USD, you can enjoy endless hours of gaming fun and earn even more BCW. So go ahead, take advantage of this offer, and let the good times roll!",
              thirddep:
                "BCW.CLUB is back with yet another incredible offer that's sure to blow your mind! Make a minimum deposit and receive a mind-boggling 250% deposit match, up to 60,000BCW, on your third deposit. Yes, you read that right! This is your chance to take your gaming experience to the next level and win big. And with a minimum recharge amount of just 120 USD, this offer is too good to pass up. So what are you waiting for? Deposit now and start winning!",
              fourthdep:
                " Are you ready for the ultimate Crypto gaming adventure? Look no further than BCW.CLUB! As a special gift from BCW, we're offering an unprecedented 300% deposit match, up to 100,000BCW, on your fourth deposit. That's right - this bonus is almost unheard of in the Crypto gaming space! With a minimum recharge amount of 150 USD, you can maximize your winnings and take your gaming experience to the next level. So don't wait any longer. Claim your bonus today and let the good times roll!",
              back: "Back",
              depositTab: {
                depositCurrency: "Deposit currency",
                record: "Record",
                chooseNetwork: "Choose network",
                depositAddress: "Deposit address",
                balance: "Balance",
                copy: "Copy",

                copied: "Copied",
                notice: "Notice",
                note: "Send only ETH to this deposit address. Coins will be deposited automatically after 6 network confirmations. Smart contract addresses are not supported(Contact us).",
              },
              swapTab: {
                getApprox: "You get approximately",
                record: "Record",
                swapFee: "Swap fee",
                fee: "Fee",
                swaped: "Swaped",
                swapNow: "Swap Now",
                invalidAmount: "Invalid Amount",
                success: "Success",
                fail:"Failed",
                swapSuccess: "Swaped Successfully",
                topup:"Topup your wallet or lower the swap amount",
                max: "Max",
                send: "Send",
                get: "Get",
              },
              withdrawTab: {
                chooseNetwork: "Choose network",
                balance: "Balance",
                withdrawAddress: "Withdraw address",
                addressPlaceholder:
                  "Fill in carefully according to the specific currency",
                notificationalret:
                  "Under Maintenance please choose another chain for withdrawal",
                undermatainance: "Under Maintenance",
                withdrawAmount: "Withdraw amount",
                receive: "You will receive",
                amountPlaceholder: "Enter the amount to be withdrawn",
                min: "Min",
                securityPurpose:
                  "For security purposes, large or suspicious withdrawal may take 1-6 hours for audit process. We appreciate your patience!",
                inProgress: "Withdrawal in progress",
                pendingApproval: "Withdrawal is pending for approval",
                frozenAssets: "Unable to withdrawal due to frozen assets",
                noGamePlayed:
                  "Unable to withdrawal due to 0 number of played games",
                lowBalance: "Unable to withdrawal due to low balance",
              },
              transactionTab: {
                deposit: "Deposit",
                withdraw: "Withdraw",
                bill: "Bill",
                all: "All",
                time: "Time",
                amount: "Amount",
                balance: "Balance",
                status: "Status",
                walletAddress: "Wallet Address",
                transaction: "Transactions",
                depositSuccessfull: "Deposit successful",
                adminDeposit: "Admin Deposit",
                details: "Details",
                orderId: "Order id",
                currency: "Chain",
                quantity: "Quantity",
                successfull: "Successful",
                rejected: "Rejected",
                unsuccessfull: "Unsuccessful",
                withdrawing: "Withdrawing",
                processing: "Processing",
                pending: "pending",
                type: "Type",
                swap: "Swap",
                swapSend: "Swap send",
                swapGet: "Swap get",
                bilswap: "Bill/Swap",
              },
            },
            userProfile: {
              frontPage: {
                userInformation: "User Information",
                userId: "User Id",
                statistics: "Statistics",
                totalWins: "Total wins",
                totalBets: "Total Plays",
                totalWagered: "Total wagered ",
                joinAt: "Joined on",
                editProfile: "Edit Profile",
              },
              editPage: {
                nickname: "Nickname",
                username: "User Name",
                editMyProfile: "Edit My Profile",
                updateMyPassword: "Update My Password",
                usernamePlaceholder: "Enter your username",
                doNotUse:
                  "Do not use special punctuation, otherwise your account may not be supported.",
                fName: "First Name",
                lName: "Last Name",
                signinEmail: "Signin Email",
                emailPlaceholder: "Enter you email",
                emailchangeError: "Unable to change email",
                modify: "Modify",
                enteryremail: "Enter your email",
                validEmail:
                  "Please enter a valid email otherwise you will not be able to verify your account.",
                verifiedEmail: "Email Verified",
                notVerifiedEmail: "Email not verified",
                sendVerificationLink: "Send Verification Link",
                verificationLinkSent: "Verification Link Sent",
                showPass: "Show Password",
                hidePass: "Hide Password",
                currentPassword: "Current Password",
                currentPassPlaceholder: "Enter you current password",
                newPass: "New Password",
                newPassPlaceholder: "Enter your new password",
                confirmPass: "Confirm Password",
                confirmPassPlaceholder: "Confirm your password",
                passLength: "Password minimum length should be 6 or greater",
                passEquality:
                  "New password should be equal to confirm password",
                invalidCurrent: "Invalid current password",
                emailChangeSuccess: "Email changed successfully",
              },
            },
            bcwModal: {
              bcwUnlock: "Unlock Bcw",
              howToUnlock: "How To Unlock",
              amountUnlockable: "AMOUNT UNLOCKABLE",
              unlocked: "Unlocked",
              claim: "Claim",
              unlock: "Unlock",
              wager: "Wager",
              minRequireToClaim: "Minimum required to claim",
              bcwRecord: "BCW Record",
              totalClaimed: "Total Claimed",
              date: "Date",
              type: "Type",
              amount: "Amount",
              deposit: "Deposit",
              claimed: "Claimed",
              spinWheel: "Spin Wheel",
              aboutBcw: "About Bcw",
              bcwUnlock: "BCW Unlock",
              whatBcw: "What is BCW ?",
              paraWhatBcw:
                "BCW (BCW Coin) is a special currency launched by BC.GAME. 1 BCW = 1 USD. You can play games, tip, coindrop & rain with BCW.",
              howToUnlock: "How to unlock BCW?",
              hotToUnlockPara:
                "Locked BCW is obtained through certain bonuses, such as deposit bonus and lucky spin. Unlocking BCW is easy! It’s essentially the same as rakeback & will unlock proportionally through wager.",
              unlockAmount: "Unlock amount",
              wagerAmount: "Wager amount",
              howToClaim: "How to claim unlocked BCW?",
              hotToClaimPara:
                "As you wager, your BCW treasure box will fill with unlocked BCW. Once you fill your treasure box with a minimum of 10BCW, click ‘claim’ and the unlocked BCW will be transferred directly to your BCW balance. That’s it! Your BCW is now immediately available to use!",
              exchangeBcw: "Can BCW be exchanged to any other currency?",
              exchangeBcwPara:
                "Sure! The most exciting thing is that the value of 1 BCW is bound to the price of 1 USDT, and you can BCSwap BCW into other currencies at any time.",
            },
          },
          allbets: {
            player: "Player",
            betting: "Playing",
            cashout: "Cash out",
            amount: "Amount",
            profit: "Profit",
          },
          gamebox: {
            graphbar: {
              bankroll: "Bankroll",
              trends: "Trends",
              understandingchart: "Understanding trend chart",
            },
            graph: {
              connecting: "Connecting...",
              youWon: "You Won",
              startsin: "Starts in",
              bang: "Bang",
            },
            betit: {
              amount: "Amount",
              autocashout: "Auto Cash Out",
              placebet: "Play",
              loading: "Loading...",
              cancel: "(Cancel)",
              nextround: "(Next Round)",
              payout: "Payout",
              min: "Min",
              max: "Max",
            },
            modals: {
              helpmodal: {
                help: "Help",
                whatGame: "What Game Is This ?",
                fairness: "Fairness",
                bankroll: "Bankroll",
                autoCashout: "Auto Cash Out",
                whatGameSection: {
                  whatThisGame: "What Game Is This ?",
                  whatCrash: "What Is CRASH?",
                  whatCrashPara:
                    "The Crash is a multiplayer game where you are allowed to cash the money after Playing. The amount you can earn will depend on how many players are Playing on the round.",
                  howToPlay: "How To Play It?",
                  howToPlayPara:
                    "Before the game starts, you have 6 seconds to place your Play. After the game starts, the multiplier will get higher and higher starting from 1X. You can click on Cash Out at any time to lock in the current multiplier, andunlocka your payoff will be your Play times the current multiplier. The longer you stay in the game, the higher payoff you will get. Please be noted, however, that the curve may crash at any moment. If you fail to cash out before the crash, you will lose all your bts. Are you going to cash out at 1.01x, or are you going to stay until 100x、1000x、10000x...? It’s all your call – which has to be made in a split of a second! (This game is not for the weak-hearted).",
                },
                fairnessSection: {
                  fairness: "Fairness",
                  isFair: "Is The Game Fair?",
                  isFairPara:
                    "We are a fair and impartial prediction and guessing platform. Our goal is to eliminate all unfair factors and make players feel comfortable and have fun. We have generated a total of 10 million hashes (the generation chain is verifiable), and each hash corresponds to a curve crash multiplier. We release these 10 million numbers in reverse order, each corresponding to one turn of the game (i.e. we have 10 million turns in total). In other words, the crash number of each turn already exists and is not calculated after the game starts. Players can therefore place their Play without concern.",
                  manipulation: "Will The Game Be Manipulated By The Platform?",
                  hashVerify: "Hash Verify",
                  manipulationPara1:
                    "The integrity check value is key to verifying whether there is any official manipulation; The test algorithm is provided as follows.",
                  example: "Example:",
                  manipulationPara2:
                    "6b5124897c3c48d0e46cc9249f08c7e560792459f1bad1171224643b5d2be231 1 :Take a random value in the 2^52 range, namely 16^13, i.e. a 13-bit hexadecimal number (because the hash value is hexadecimal, 2^52 === 16^13)6b5124897c3c4 (0x6b5124897c3c4 equals 1887939992208324 in the decimal system).",
                  manipulationPara3:
                    "2 :Distribute the random value to 0~1, by dividing it by the maximum value of 13 fs, namely 0x6b5124897c3c4/0x10000000000000. Given the discrete random nature of the hash value, we then can think that any hash value can be transformed into a random number of 0~1,",
                  manipulationPara4:
                    "3 :Make the house edge 1%. Further to calculate 99/(1-X), where X is the random value calculated at Step 2. When X is 0, the result is 99; when X is 1, the result is positive infinite; when X is 0.01, the result is 100; when X is less than 0.01, the result is less than 100. Conclusion: The overall random number distribution is 99 to positive infinite; and when the random number distribution is 0~0.01, the result is less than 100. 99/(1-0.419206889692064) = 170.45656748150867",
                  manipulationPar5:
                    "4 :All values less than 100 will be set to 100. In other words, there is a probability of 1% that 100 will appear. Round off the number and divide it by 100 to get the final result. 170/100 = 1.70 Conclusion: The hash value used in the game is inverse ordered. Therefore, with the SHA256 algorithm, a previous hash used in the game can be calculated from its subsequent hash. Since there is one-to-one correspondence between the key and the value of hash, we can draw the conclusion that if a hash can be used to calculate the hash that precedes it, then this hash should have been already generated when the preceding prize is announced. Similarly, the entire hash chain is generated at the very beginning and cannot be changed once generated. Otherwise, it cannot pass verification by SHA256, and as far as the payout is concerned, this is nothing more than a probability game in which crash is a given. The official organizer cannot manipulate any game set. Therefore, CRASH is more transparent than other methods. This is the cornerstone on which our game is built. Simple calculation: When the 13-bit hash value is 8000000000000 = 1.98, 0xb000000000 = 3.168, 0xc000000000 = 3.96, that is, the first digit is greater than 8((16-8)/16≈0.5), the result is approximately 2x; when the first digit is greater than b((16-11)/16≈0.3), the result is approximately 3x; and when the first digit is greater than c((16-12)/16≈0.25), the result is approximately 4x, and the same rule applies to the rest. When the 13-bit hash value is f000000000000 = 15.84, ff00000000000 = 253.44, fff000000",
                },
                bankrollSection: {
                  bankroll: "Bankroll",
                  whatBankroll: "What is the bankroll?",
                  bankrollPara:
                    "The bankroll is the pool of money that the bankroller uses to pay out winners of the game. The max profit that players can win from a round of the game is determined by the size of the bankroll. The larger the bankroll, the more players can win. Each player can only win 0.75% of the bankroll per round All players can only win 1.125% of the funds per round Players can Play on the bankroll (i.e. become bankrollers), and their Play is added to the bankroll such that they win when the house wins and they lose when the house loses.",
                  poolFunds: "How does the pool of funds operate?",
                  poolFundsPara:
                    "The bankroll implements a shareholding system that allows everyone to participate and obtain the corresponding shares.",
                  houseEdge: " The house edge is 1%",
                  poolFundsParaLeft:
                    ".99% of each Play will go to the bankroll, and the remaining 1% will be reserved for platform operating costs. Payouts made to the winning players will be deducted from the bankroll.",

                  maxProfit: "Max Profits?",
                  maxProfitPara:
                    "When your Playing profit exceeds the maximum profit, the system will automatically settle to the maximum profit Different currencies have different max profits as follows",
                },
                autoCashoutSection: {
                  auto: "Auto Cash Out",
                  internetLag: "Why Is There Internet Lag?",
                  internetLapPara:
                    "Since CRASH is a real-time online game (a game in which customers interact with it via the Internet), there is a delay between the time you click on the Cash Out button and the time when the server receives your cash out instruction. The farther away you are from the server and the worse your Internet connection is, the longer it will take for your message to reach the game server. In a perfect environment, your message can travel to the server at the speed of light, but it still takes 134 milliseconds to travel around the world.",
                  autoCashout: "What's the Use of Automatic Cash Out?",
                  autoCashuotPara:
                    "The best way to avoid damages caused by Internet lag is to use the automatic cash out function. Since your automatic cash out is sent to the server at the same time when you place your Play, the server can execute your cash out instruction precisely and regardless of the lag For example, if your connection is bad and you want to cash out at 2x, then we recommend that you set automatic cash out to 2x rather than cash out manually at 2x, because after you click on “Cash Out”, the curve may crash before your message reaches the server.",
                  acciedentlyDisconnected:
                    " What Should You Do If the Game Is Accidentally Disconnected?",
                  acciedentlyDisconnectedPara:
                    "When we notice that you are disconnected from an active game, we will try to cash out for you. However, we strongly recommend that you use the automatic cash out function to deal with this issue. Since your automatic cash out multiplier has been sent to the server, you can still cash out normally even if you are completely disconnected. This is the most reliable way to avoid damages caused by accidental disconnection.",
                },
              },
              keysmodal: {
                hotkeys: "Hot Keys",
                half: "Half Play amount",
                double: "Double Play amount",
                betoperation: "Place Play | Cashout",
              },
            },
          },
          stats: {
            mybetstxt: "My History",
            historytxt: "History",
            highrollerstxt: "High rollers",
            mybets: {
              betid: "Play ID",
              bet: "Play",
              time: "Time",
              payout: "Payout",
              profit: "Profit",
            },
            history: {
              gameid: "Game ID",
              result: "Result",
              hash: "Hash",
              verify: "Verify",
            },
            highrollers: {
              player: "Player",
              betamount: "Play amount",
              multiplier: "Multiplier",
              profitamount: "Profit amount",
            },
          },
          feedback: {
            heading1: "Crypto Online BCW.Club",
            formTitle: "Help us improve your experience",
            para1:
              "BCW.Club online have not always been around, but we can safely say that online BCW.Club have been used a lot since they came on the market. And it's not in short demand nor options, and now in 2022, we have 1000s and 1000s to pick from - it's just a matter of what you like and what payment options you would like to see at the BCW.Club.",
            para2:
              "Players are always looking for something new, which will help make the gaming experience so much better and more accessible. Allowing the player to focus on the absolute fun of a BCW.Club, that's right, the games themselves.",
            leaveMessage: "Leave a messages",
            getReward: "Now get rewarded for your valuable feedback.",
            placeHolder:
              "If you find any bugs or usability difficulties please let us know,leave your messages right here.",
            feedbackSent: "Feed back sent successfully",
            feedbackErr: "Something went wrong please try again.",
            emptyBox: "Message box can't be empty.",
          },
          footer: {
            acceptednetwork: "Accepted networks",
            para: "BCW.Club loved and trusted by millions of users globally. BCW.CLUB is a community-based crypto gaming that offers their players the best online gaming experience possible! At BCW.CLUB, we are convinced that blockchain will change the online gaming industry forever! Jump in and check it out for yourself! Have fun and earn crypto!",
          },
        },
      },
      Indonesian: {
        translation: {
          header: {
            security2Fa: {
              security2FA: "Keamanan-2FA",
              download: "Unduh dan pasang.",
              downloadLink: " Google Authenticator.",
              downloadParaLeft:
                " Aktifkan Otentikasi Dua Faktor untuk melindungi akun Anda dari akses tidak sah.",
              scanQr:
                "Pindai kode QR dengan Aplikasi Google Authenticator Anda atau masukkan kunci rahasia secara manual.",
              verificationCode: "Kode verifikasi",
              yourSecretKey: "Kode verifikasi",
              enable2Fa: "Aktifkan 2FA",
              disable2Fa: "Nonaktifkan 2FA",
              para: "Tulis kode ini, jangan pernah mengungkapkannya kepada orang lain. Anda dapat menggunakannya untuk mendapatkan kembali akses ke akun Anda jika tidak ada akses ke autentikator.",
            },
            banner: {
              refruend: "Referensikan teman untuk mendapatkan ",
              comision: "komisi 15%. ",
              earn: "Daftar & Dapatkan",
              term: "Syarat & Ketentuan Referensi",
              reward: "Dapatkan hadiah rujukan Anda",
              detail:
                "Setiap teman yang Anda undang, akan mendapatkan uang, semakin banyak Anda mengundang, semakin banyak yang akan Anda dapatkan!",
              rewardinpersent: "Dapatkan imbalan komisi 15% Anda ",
              resivedreward:
                "Anda akan menerima hadiah komisi setiap kali teman Anda memasang taruhan berdasarkan permainan. ",
              dashbord: "Buka ke Dasbor",
            },
            question: {
              qone: "Bagaimana sistem rujukan bekerja?",
              ansone:
                "Saat Anda membagikan tautan referensi Anda dengan salah satu teman, keluarga, atau iklan Anda, seseorang mendaftar untuk bermain di BCW.CLUB, pemain tersebut menjadi referensi Anda dan akan memberi Anda komisi dan manfaat tambahan.",
              qtwo: "Berapa banyak yang dapat saya peroleh dengan merujuk teman?",
              anstwo:
                "Per referensi, Anda bisa mendapatkan 15% * 1% dari taruhan mereka.",
              qthre: "Dapatkah saya melihat data referral saya?",
              ansthre:
                "Ya, BCW.CLUB meyakini transparansi penuh dan menyediakan semua informasi pengguna, termasuk nama pengguna, taruhan yang dipasang, dan komisi yang diperoleh. Semuanya ada di dasbor afiliasi Anda.",
              qfour:
                "Bagaimana cara melacak jumlah pemain yang telah saya referensikan?",
              ansfour:
                "Anda dapat melihat penghasilan Anda dan statistik lainnya melalui dasbor program afiliasi.",
              qfive:
                "Apa saja pilihan pembayaran yang tersedia untuk afiliasi?",
              ansfive:
                "Hadiah yang Anda peroleh adalah dalam bentuk BCW, koin game resmi kami. Koin BCW dapat ditukar dengan mata uang kripto apa pun yang didukung di platform. Setelah Anda mendapatkan uang melalui referensi, Anda dapat menambahkannya ke dompet Anda dari dasbor afiliasi.",
              qsix: "Dukungan pelanggan seperti apa yang tersedia untuk pemain game BCW.Club online?",
              anssix:
                "BCW.CLUB memiliki tim dukungan pelanggan khusus yang tersedia untuk membantu pemain dengan pertanyaan atau masalah apa pun yang mungkin mereka miliki. Sebagai afiliasi, penting untuk mempromosikan permainan BCW.Club online tepercaya dan berkualitas tinggi yang menawarkan dukungan pelanggan yang sangat baik",
              qseven: "Berapa ambang pembayaran minimum?",
              ansseven:
                "Ambang pembayaran minimum adalah jumlah minimum komisi yang harus Anda peroleh sebelum Anda dapat meminta pembayaran. Di BCW.CLUB tidak ada batas minimum; Anda dapat mengklaim penghasilan Anda kapan saja.",
            },
            signin: {
              signin: "Masuk",
              email: "Surel",
              loginPassword: "Kata sandi login",
              forgotPass: "Lupa kata sandi",
              directSignin: "Daftar langsung dengan",
              resetPass: "Setel ulang kata sandi",
              haveAccount: "Sudah memiliki akun?",
              enteremail: "Masukan email",
              enterpassword: "Masukkan kata kunci ",
              emailaddress: " alamat email ",
              register:"Alamat Email Terdaftar",
            },
            signup: {
              signup: " Mendaftar",
              email: "alamat email",
              password: "Kata sandi login",
              daily:"SEHARI-HARI",
              win:"MENANG",
              spinthewheel:"Putar rodanya",
              winfreecrypto:"MENANGKAN CRYPTO GRATIS!",
              agreement:
                "Saya setuju dengan Perjanjian Pengguna & mengonfirmasi bahwa saya berusia minimal 18 tahun",
              directSignup: "Daftar langsung dengan",
              referral: "Kode Promo Referensi (Opsional)",
              enterreferral: "Masukkan Kode Referensi",
              referral: " Rujukan",
              enterrefcode: "masukkan kode referral anda",
              enterpassword: "Masukkan kata kunci",
              passwordrequired: "katakunci dibutuhkan",
            },
            chat: {
              chat: "Chat",
              chatRules: "Aturan Obrolan",
              message: "pesan Anda",
              global: "Global",
              rule1:
                "Jangan mengirim spam, melecehkan, atau menyinggung pengguna lain. Juga, hindari menggunakan CAPS! Tidak ada yang suka diteriaki!",
              rule2:
                "Jangan mengemis atau meminta pinjaman, hujan, tip, dan koin dua kali lipat.",
              rule3:
                "Tidak ada perilaku mencurigakan yang dapat dilihat sebagai potensi penipuan",
              rule4:
                "Jangan terlibat dalam segala bentuk layanan iklan/ perdagangan/ jual/ beli atau penawaran.",
              rule5:
                "Jangan gunakan penyingkat URL. Selalu kirimkan tautan aslinya",
              rule6:
                "Gunakan ruang obrolan bahasa yang ditentukan sesuai dengan itu.",
            },
            referral: {
              spin: "Putaran",
              menu: "Menu",
              ern: "Menghasilkan",
              crypto: "Kripto",
              fiat: "Perintah",
              hidempty: "Sembunyikan Kosong",
              search: "Mencari",
              cardnumber:"Nomor Kartu / Nomor Rekening",
              chtroom: "Ruang obrolan",
              dashbord: " pergi ke dasbor",
              question: "Pertanyaan yang Sering Diajukan",
              Affiliate: "Afiliasi",
              Logout: "keluar",
              stat: "Statistik",
              bcs: "BCSwap",
              trans: "Transaksi",
              currencynotavailable:"Mata Uang Tidak Tersedia, Silakan pilih yang lain",
              tot: "Total",
              userinfo: "informasi pengguna",
              free: "Gratis Berikutnya",
              rerearn: "Rujuk dan Dapatkan",
              vip: "Fasilitas VIP saya",
              earn: "Putar dan Dapatkan",
              Casno: "Game Asli",
              BCWOriginals: "BCW Originals",
              Crash: " crash",
              Promo: "Promosi",
              free: "Gratis Berikutnya",
              tot: "total",
              TotalEarned: "Total Hadiah yang Didapatkan",
              username: "Nama pengguna",
              userId: "Id pengguna",
              Referfriend: " Menunjuk teman",
              TotalFrReferred: "Total Friends Referred:",
              totacommission: "Komisi Total",
              totalwager: "Taruhan Total",
              shareyourreferralink: "Bagikan tautan rujukan Anda",
              claimed: "Diklaim ",
              update: "memperbarui",
              alplyer:"semua pemain",
              referralmanagement: "Manajemen Referensi",
              totalFriendsreferred: "Jumlah Teman yang Direferensikan",
              claimnow: "klaim sekarang",
              oop: "Ups! Belum ada data!",
              bankroll: " Bankroll",
              Notclaimed: "Tidak diklaim",
              mores: "Lainnya",
              notices: " Pemberitahuan",
              alplyer: "semua pemain",
              fee: "biaya",
              invalidAmount: "Jumlah tidak valid ",
            },
            span: {
              wheel: " Roda Hadiah",
              spannow: "berputar sekarang",
            },
            wallet: {
              name: "nama",
              wallet: "Dompet",
              deposit: "Deposito",
              buy: "Beli",
              vault: "Vault",
              maxamount:"Jumlah maksimum seharusnya",
              minamount:"Jumlah minumum harus",
              swap: "Menukar",
              toppay: "Toppay",
              confirm: "Mengonfirmasi",
              safty:
                "Mengarahkan ke halaman deposit, Didukung oleh BCW .Club resmi dan penyedia tepercaya.",
              safety:
                "Untuk pertanyaan apa pun, hubungi Dukungan Langsung 24 jam kami",
              metod: "Pilih metode pembayaran",
              bankdeposit: "Setoran Fiat - Transfer Bank",
              bankwithdraw: "Penarikan Fiat - Transfer Bank",
              accountholder: "Pemilik akun",
              bankname: "Nama Bank",
              crypto: "Kripto",
              bankaccount: "Akun bank",
              idcard: "KTP",
              phone: "Telepon",
              withdraw: "Menarik",
              transaction: "transaksi",
              secureAsset: "Untuk mengamankan aset anda,",
              please: "tolong",
              enableFa: "Aktifkan 2FA",
              disableFa: "Nonaktifkan 2FA",
              mostpara:
                "Bagian paling menarik dari pelapisan di BCW.Club crypto adalah bonus yang ditawarkan! BCW.CLUB, platform perjudian kripto terkemuka di dunia menawarkan kepada Anda, pemain setia kami, bukan 1 tetapi 4 bonus setoran yang bermanfaat.",
              mostparaone:
                "Bagian terbaik tentang memiliki 4 bonus adalah Anda dapat menikmati perjudian kripto online dengan bantuan dari BCW.Club crypto paling ramah dan paling bermanfaat di luar sana! Tidak ada bonus deposit seperti BCW.CLUB dengan total kecocokan deposit 1050%.",
              notonly:
                "Ini bukan hanya waktu yang tepat untuk membuat kripto ekstra tetapi ini adalah kesempatan Anda untuk mendapatkan beberapa koin kripto kami sendiri, BCW coin (BCW) Anda akan dihargai dengan BCW untuk digunakan setoran Anda atas kebijakan Anda.",
              fristdeposit: "Bonus Setoran Pertama",
              secondbon: "Bonus Setoran Kedua",
              thirdbon: "Bonus Setoran Ketiga",
              fourthbon: "Bonus Setoran ke-4",
              fristbonce:
                "Selamat datang di BCW.CLUB, Lakukan deposit hari ini dan dapatkan pertandingan deposit 250%(hingga 20,000BCW) besar-besaran di BCW.CLUB BCW.Club kripto! Taruhan sekarang untuk mendapatkan BCW di dompet Anda! Jumlah isi ulang minimal 30 USD ",
              seconddep:
                "Bonus setoran kedua sebesar 250%(hingga 40,000BCW) menanti Anda dengan setoran kedua ke BCW.Club kripto terbaik dunia! Jangan menunggu dan nikmati lebih banyak kesenangan perjudian kripto sekarang! Jumlah isi ulang minimal 60 USD",
              thirddep:
                "Bonus setoran 250%(hingga 60,000BCW) lainnya hanya untuk Anda! Yang harus Anda lakukan adalah melakukan setoran minimum untuk mendapatkan bonus seperti tidak ada bonus setoran yang ditawarkan di tempat lain ! Setor sekarang untuk menang!Jumlah isi ulang minimal 120 USD ",
              fourthdep:
                "Hadiah spesial dari BCW.CLUB! Bonus setoran keempat 300%(hingga 100,000BCW)! Hampir tidak pernah terdengar di ruang perjudian kripto. Jangan menunggu, manfaatkan ini bonus deposit BCW.Club crypto dan menangkan besar! Jumlah isi ulang minimal 150 USD ",
              back: "kembali",

              depositTab: {
                depositCurrency: "Deposit mata uang",
                record: "Rekam",
                chooseNetwork: "Pilih jaringan",
                depositAddress: "Alamat deposito",
                balance: "Saldo ",
                copy: "Menyalin",
                copied: "Disalin",
                notice: "Pemberitahuan ",
                note: "Kirim hanya USDT ke alamat deposit ini. Koin akan disetorkan secara otomatis setelah 6 konfirmasi jaringan. Alamat kontrak pintar tidak didukung (Hubungi kami).",
              },
              swapTab: {
                getApprox: "Anda mendapatkan kira-kira",
                record: "Rekam",
                swapFee: "Biaya swap",
                swapNow: "Tukar sekarang",
                swaped: "Ditukar",
                fail:"Gagal",
                invalidAmount: "Jumlah tidak valid",
                success: "kesuksesan",
                swapSuccess: "Berhasil ditukar",
                topup:"Isi ulang dompet Anda atau kurangi jumlah swap",
                max: "Maksimal",
                send: "Kirim",
                get: "Dapatkan",
              },
              withdrawTab: {
                chooseNetwork: "Pilih jaringan",
                balance: "keseimbangan",
                withdrawAddress: "Alamat penarikan",
                addressPlaceholder:
                  "Isi dengan hati-hati sesuai dengan mata uang tertentu",
                withdrawAmount: "Jumlah penarikan",
                receive: "Anda akan menerima",
                amountPlaceholder: "Masukkan jumlah yang akan ditarik",
                undermatainance: "Dalam Pemeliharaan",
                notificationalret:
                  "Dalam Pemeliharaan, Silakan pilih chain lain untuk penarikan",
                min: "Min",
                securityPurpose:
                  "Untuk tujuan keamanan, penarikan besar atau mencurigakan mungkin memakan waktu 1-6 jam untuk proses audit. Kami menghargai kesabaran Anda!",
                inProgress: "Penarikan sedang berlangsung",
                pendingApproval: "Penarikan sedang menunggu persetujuan",
                frozenAssets: "Tidak dapat ditarik karena aset dibekukan",
                noGamePlayed:
                  "Tidak dapat penarikan karena 0 jumlah permainan yang dimainkan",
                lowBalance: "Tidak dapat menarik karena saldo rendah",
              },
              transactionTab: {
                deposit: "Menyetorkan",
                withdraw: "Menarik",
                bill: "Tagihan",
                bilswap: "Tagihan/Swap",
                all: "Semua",
                time: "Waktu",
                balance: "Keseimbangan",
                amount: "Jumlah",
                status: "Negara",
                walletAddress: "Alamat Dompet",
                transaction: "Transaski",
                depositSuccessfull: "Deposit berhasil",
                adminDeposit: "Setoran Admin",
                details: "Detil",
                orderId: "Id pesanan",
                currency: "Mata uang",
                quantity: "Kuantitas",
                successfull: "Berhasil",
                rejected: "Ditolak",
                unsuccessfull: "Gagal",
                withdrawing: "Penarikan",
                processing: "Pengolahan",
                pending: "Tertunda",
                type: "Type",
                swap: "Swap",
                swapSend: "Swap hanya",
                swapGet: "Swap mendapatkan",
              },
            },
            userProfile: {
              frontPage: {
                userInformation: "Informasi pengguna",
                userId: "Id pengguna",
                statistics: "Statistik",
                totalWins: "Total kemenangan",
                totalBets: "Total taruhan",
                totalWagered: "Taruhan total",
                joinAt: "Bergabung pada",
                editProfile: "Sunting Profil Saya",
              },
              editPage: {
                nickname: "Nama Panggilan",
                username: "Nama pengguna",
                editMyProfile: "Sunting Profil Saya",
                updateMyPassword: "perbarui kata sandi saya",
                usernamePlaceholder: "masukkan nama pengguna Anda",
                doNotUse:
                  "Jangan gunakan tanda baca khusus jika tidak, akun Anda mungkin tidak didukung",
                fName: "Nama depan ",
                lName: "Nama keluarga",
                signinEmail: "masuk email",
                emailPlaceholder: "Masukkan email Anda",
                emailchangeError: "Unable to change email",
                validEmail:
                  "Silakan masukkan email yang valid jika tidak, Anda tidak akan dapat memverifikasi akun Anda.",
                verifiedEmail: " Email Terverifikasi",
                notVerifiedEmail: "Email tidak diverifikasi",
                sendVerificationLink: "kirim tautan verifikasi",
                modify: "Memodifikasi",
                verificationLinkSent: " Tautan Verifikasi Terkirim",
                showPass: "  tampilkan kata sandi",
                hidePass: "sembunyikan kata sandi",
                currentPassword: "kata sandi saat ini",
                currentPassPlaceholder: "Masukkan kata sandi Anda",
                newPass: "kata sandi baru",
                enteryremail: "Masukkan email Anda",
                newPassPlaceholder: "Masukan kata sandi baru",
                confirmPass: "Confirm Password",
                confirmPassPlaceholder: "Konfirmasi kata sandi Anda",
                passChangeSuccess: "Kata sandi berhasil diperbarui",
                passLength: "Panjang minimum kata sandi harus 6 atau lebih",
                passEquality:
                  " Kata sandi baru harus sama dengan konfirmasi kata sandi",
                invalidCurrent: " Kata sandi salah",
                emailChangeSuccess: " Email berhasil diubah",
              },
            },
            bcwModal: {
              bcwUnlock: "Menmbuka kunci Bcw",
              howToUnlock: "Cara membuka kunci bcw",
              amountUnlockable: "Jumlah yang tidak dapat dibuka",
              unlocked: "tidak Terkunci",
              claim: "Mengeklaim",
              unlock: "Membuka kunci",
              wager: "Taruhan",
              minRequireToClaim: "Minimum yang diperlukan untuk mengklaim",
              bcwRecord: "Rekor BCW",
              totalClaimed: "Total Diklaim",
              date: "Tanggal",
              type: "Jenis",
              amount: "Jumlah",
              deposit: "Menyetorkan",
              claimed: "Diklaim",
              spinWheel: "Putar Roda",
              aboutBcw: "Tentang Bcw",
              bcwUnlock: "Buka Kunci BCW",
              whatBcw: "Apa itu BCW?",
              paraWhatBcw:
                "BCW (BC Dollar) adalah mata uang khusus yang diluncurkan oleh BC.GAME. 1 BCW = 1 USD. Anda dapat memainkan game, tip, coindrop & hujan dengan BCW.",
              howToUnlock: "Bagaimana cara membuka kunci BCW?",
              hotToUnlockPara:
                "Locked BCW didapatkan melalui bonus tertentu, seperti bonus deposit dan lucky spin. Membuka kunci BCW itu mudah! Ini pada dasarnya sama dengan rakeback & akan terbuka secara proporsional melalui taruhan.",
              unlockAmount: "Buka jumlah",
              wagerAmount: "Jumlah taruhan",
              howToClaim: "Bagaimana cara mengklaim BCW yang tidak terkunci?",
              hotToClaimPara:
                "Saat Anda  bermain, kotak harta karun BCW Anda akan terisi dengan BCW yang tidak terkunci. Setelah Anda mengisi kotak harta Anda dengan minimal 10BCW, klik 'klaim' dan BCW yang tidak dikunci akan ditransfer langsung ke saldo BCW Anda. Itu dia! BCW Anda sekarang segera tersedia untuk digunakan!",
              exchangeBcw: "Apakah BCW dapat ditukar dengan mata uang lain?",
              exchangeBcwPara:
                "Tentu! Hal yang paling menarik adalah bahwa nilai 1 BCW terikat pada harga 1 USDT, dan Anda dapat menukar BCS ke mata uang lain kapan saja.",
            },
          },
          allbets: {
            player: "Pemain",
            betting: "Sedang Main",
            cashout: "Menguangkan",
            amount: "Jumlah",
            profit: "Untung",
          },
          gamebox: {
            graphbar: {
              bankroll: "Bankroll",
              trends: "Tren",
              understandingchart: "Memahami  gratif tren",
            },
            graph: {
              connecting: "menghubungkan...",
              youWon: "Kamu Menang",
              startsin: "Dimulai dalam",
              bang: "ledakan",
            },
            betit: {
              amount: "jumlah",
              autocashout: "Pencairan otomatis",
              placebet: "Main",
              loading: "Memuat...",
              cancel: "(Batal)",
              nextround: "(Babak Selanjutnya)",
              payout: "Pembayaran",
              min: "Min",
              max: "Max",
            },
            modals: {
              helpmodal: {
                help: "Bantuan",
                whatGame: "Permainan apa ini?",
                fairness: "Keadilan",
                bankroll: "Bankroll",
                autoCashout: "Pencairan otomatis",
                whatGameSection: {
                  whatThisGame: "Permainan apa ini?",
                  whatCrash: "Apa itu CRASH?",
                  whatCrashPara:
                    "Crash adalah gim multipemain yang memungkinkan Anda mencairkan uang setelah  bermain. Jumlah yang bisa Anda peroleh akan bergantung pada berapa banyak pemain yang  bermain pada ronde tersebut.",
                  howToPlay: "Bagaimana Cara Memainkannya?",
                  howToPlayPara:
                    "Sebelum permainan dimulai, Anda memiliki 6 detik untuk memasang taruhan Anda. Setelah permainan dimulai, pengganda akan semakin tinggi mulai dari 1X. Anda dapat mengklik Cash Out kapan saja untuk mengunci pengganda saat ini, dan pembayaran Anda akan menjadi taruhan Anda dikalikan dengan pengganda saat ini. Semakin lama Anda bertahan dalam permainan, semakin tinggi hasil yang akan Anda dapatkan. Harap dicatat, bagaimanapun, bahwa kurva dapat macet kapan saja. Jika Anda gagal menguangkan sebelum crash, Anda akan kehilangan semua taruhan Anda. Apakah Anda akan menguangkan pada 1,01x, atau Anda akan bertahan hingga 100x、1000x、10000x...? Itu semua panggilan Anda - yang harus dilakukan dalam sepersekian detik! (Game ini bukan untuk yang lemah hati).",
                },
                fairnessSection: {
                  fairness: "Keadilan",
                  isFair: "Apakah Permainannya Adil?",
                  isFairPara:
                    "Kami adalah platform prediksi dan tebakan yang adil dan tidak memihak. Tujuan kami adalah menghilangkan semua faktor yang tidak adil dan membuat pemain merasa nyaman dan bersenang-senang. Kami telah menghasilkan total 10 juta hash (rantai pembuatan dapat diverifikasi), dan setiap hash sesuai dengan pengganda kerusakan kurva. Kami merilis 10 juta angka ini dalam urutan terbalik, masing-masing sesuai dengan satu putaran permainan (yaitu kami memiliki total 10 juta putaran). Dengan kata lain, crash number tiap turn sudah ada dan tidak dihitung setelah permainan dimulai. Oleh karena itu, pemain dapat memasang taruhan mereka tanpa khawatir.",
                  manipulation: "Apakah Game Akan Dimanipulasi Oleh Platform? ",
                  hashVerify: "Verifikasi Hash",
                  manipulationPara1:
                    "Nilai pemeriksaan integritas adalah kunci untuk memverifikasi apakah ada manipulasi resmi; Algoritma pengujian disediakan sebagai berikut.",
                  example: "Contoh:",
                  manipulationPara2:
                    "6b5124897c3c48d0e46cc9249f08c7e560792459f1bad1171224643b5d2be231 1 : Ambil nilai acak dalam rentang 2^52, yaitu 16^13, yaitu bilangan heksadesimal 13-bit (karena nilai hash adalah heksadesimal, 2^52 === 16^13)6b5124897c3c4 (0x6b5124897c3c4 sama dengan 1887939992208324 dalam sistem desimal).",
                  manipulationPara3:
                    "2 : Bagikan nilai acak menjadi 0~1, dengan membaginya dengan nilai maksimum 13 fs, yaitu 0x6b5124897c3c4/0x10000000000000. Mengingat sifat acak diskrit dari nilai hash, kita kemudian dapat berpikir bahwa setiap nilai hash dapat diubah menjadi angka acak 0~1,",
                  manipulationPara4:
                    "3 : Buat tepi rumah 1%. Selanjutnya menghitung 99/(1-X), dimana X adalah nilai acak yang dihitung pada Langkah 2. Ketika X adalah 0, hasilnya adalah 99; ketika X adalah 1, hasilnya positif tak terhingga; ketika X adalah 0,01, hasilnya adalah 100; ketika X kurang dari 0,01, hasilnya kurang dari 100. Kesimpulan: Distribusi bilangan acak keseluruhan adalah 99 hingga positif tak terhingga; dan ketika distribusi angka acak adalah 0~0,01, hasilnya kurang dari 100.99/(1-0,419206889692064) = 170,45656748150867",
                  manipulationPar5:
                    "4 : Semua nilai kurang dari 100 akan diatur ke 100. Dengan kata lain, ada kemungkinan 1% bahwa 100 akan muncul. Bulatkan angkanya dan bagi dengan 100 untuk mendapatkan hasil akhir. 170/100 = 1,7 Kesimpulan: Nilai hash yang digunakan dalam game diurutkan terbalik. Oleh karena itu, dengan algoritme SHA256, hash sebelumnya yang digunakan dalam game dapat dihitung dari hash berikutnya. Karena ada korespondensi satu-ke-satu antara kunci dan nilai hash, kita dapat menarik kesimpulan bahwa jika hash dapat digunakan untuk menghitung hash yang mendahuluinya, maka hash ini seharusnya sudah dibuat saat hadiah sebelumnya diumumkan. Demikian pula, seluruh rantai hash dibuat di awal dan tidak dapat diubah setelah dibuat. Jika tidak, itu tidak dapat lulus verifikasi oleh SHA256, dan sejauh menyangkut pembayaran, ini tidak lebih dari permainan probabilitas di mana kecelakaan diberikan. Penyelenggara resmi tidak dapat memanipulasi set permainan apa pun. Oleh karena itu, CRASH lebih transparan daripada metode perjudian lainnya. Ini adalah landasan di mana game kami dibuat. Perhitungan sederhana: Ketika nilai hash 13-bit adalah 8000000000000 = 1,98, 0xb000000000 = 3,168, 0xc000000000 = 3,96, yaitu digit pertama lebih besar dari  ((16-8)/16≈0,5), hasilnya kira-kira 2x; ketika digit pertama lebih besar dari b((16-11)/16≈0.3), hasilnya kira-kira 3x; dan ketika digit pertama lebih besar dari c((16-12)/16≈0.25), hasilnya kira-kira 4x, dan aturan yang sama berlaku untuk sisanya. Ketika nilai hash 13-bit adalah f000000000000 = 15,84, ff00000000000 = 253,44, fff000000",
                },
                bankrollSection: {
                  bankroll: "Bankroll",
                  whatBankroll: "Apa bankrollnya?",
                  bankrollPara:
                    "Bankroll adalah kumpulan uang yang digunakan bankroller untuk membayar pemenang permainan. Keuntungan maksimal yang bisa dimenangkan pemain dari satu putaran permainan ditentukan oleh ukuran bankroll. Semakin besar bankroll, semakin banyak pemain yang bisa menang. Setiap pemain hanya dapat memenangkan 0,75% dari uang per putaran Semua pemain hanya dapat memenangkan 1,125% dari dana per putaran Pemain dapat  bermain pada bankroll (yaitu menjadi bankroller), dan taruhan mereka ditambahkan ke bankroll sedemikian rupa sehingga mereka menang saat rumah menang dan kalah saat rumah kalah. ",
                  poolFunds: "Bagaimana kumpulan dana beroperasi?",
                  poolFundsPara:
                    "Bankroll menerapkan sistem kepemilikan saham yang memungkinkan setiap orang untuk berpartisipasi dan mendapatkan saham yang sesuai.",
                  houseEdge: "Tepi rumah adalah 1%",
                  poolFundsParaLeft:
                    ".99% dari setiap taruhan akan masuk ke bankroll, dan 1% sisanya akan dicadangkan untuk biaya pengoperasian platform. Pembayaran yang dilakukan kepada pemain yang menang akan dikurangkan dari bankroll.",
                  investment: "Bagaimana kumpulan dana beroperasi?",
                  maxProfit: "Keuntungan Maksimal?",
                  maxProfitPara:
                    "Ketika keuntungan taruhan Anda melebihi keuntungan maksimum, sistem akan secara otomatis menetapkan keuntungan maksimum",
                },
                autoCashoutSection: {
                  auto: "Pencairan otomatis",
                  internetLag: "Mengapa Internet Lag?",
                  internetLapPara:
                    "Karena CRASH adalah game online real-time (game di mana pelanggan berinteraksi dengannya melalui Internet), ada penundaan antara waktu Anda mengklik tombol Uang Keluar dan waktu ketika server menerima instruksi uang tunai Anda . Semakin jauh Anda dari server dan semakin buruk koneksi Internet Anda, semakin lama waktu yang dibutuhkan pesan Anda untuk mencapai server game. Di lingkungan yang sempurna, pesan Anda dapat dikirimkan ke server dengan kecepatan cahaya, tetapi masih membutuhkan 134 milidetik untuk bepergian ke seluruh dunia.",
                  autoCashout: "Apa Gunanya Cash Out Otomatis?",
                  autoCashuotPara:
                    "Cara terbaik untuk menghindari kerusakan yang disebabkan oleh kelambatan internet adalah dengan menggunakan fungsi cash out otomatis. Karena cash out otomatis Anda dikirim ke server bersamaan dengan saat Anda memasang taruhan, server dapat mengeksekusi instruksi cash out Anda dengan tepat dan terlepas dari lag Misalnya, jika koneksi Anda buruk dan Anda ingin cash out 2x , maka kami menyarankan Anda mengatur pencairan otomatis menjadi 2x daripada mencairkan secara manual di 2x, karena setelah Anda mengklik Cash Out, kurva mungkin macet sebelum pesan Anda mencapai server.",
                  acciedentlyDisconnected:
                    "Apa yang Harus Anda Lakukan Jika Game Terputus Secara Tidak Sengaja?",
                  acciedentlyDisconnectedPara:
                    "Ketika kami melihat bahwa Anda terputus dari permainan aktif, kami akan mencoba menguangkan untuk Anda. Namun, kami sangat menyarankan agar Anda menggunakan fungsi pencairan otomatis untuk mengatasi masalah ini. Karena pengganda pencairan otomatis Anda telah dikirim ke server, Anda masih dapat mencairkan secara normal meskipun Anda benar-benar terputus. Ini adalah cara paling andal untuk menghindari kerusakan yang disebabkan oleh pemutusan sambungan yang tidak disengaja.",
                },
              },
              keysmodal: {
                hotkeys: "Tombol pintas",
                half: "Taruhan Setengah",
                double: "Taruhan Ganda",
                betoperation: "Taruhan-menguangkan",
              },
            },
          },
          stats: {
            mybetstxt: "Pemain",
            historytxt: "Riwayat",
            highrollerstxt: "Pemain besar",
            mybets: {
              betid: "Bermain id",
              bet: "Main",
              time: "Waktu",
              payout: "Pembayaran",
              profit: "Untung",
            },
            history: {
              gameid: "Game ID",
              result: "Hasil",
              hash: "Hash",
              verify: "Verifikasi",
            },
            highrollers: {
              player: "Pemain",
              betamount: "Jumlah taruhan",
              multiplier: "Pengganda",
              profitamount: "Jumlah keuntungan",
            },
          },
          feedback: {
            heading1: "BCW.Club Kripto Online",
            formTitle: "Bantu kami meningkatkan pengalaman Anda",
            para1:
              "BCW.Club online tidak selalu ada, tetapi kami dapat dengan aman mengatakan bahwa BCW.Club online telah banyak digunakan sejak mereka muncul di pasaran. Dan itu bukan permintaan sedikit atau pilihan, dan sekarang di tahun 2022, kami memiliki jumlah besar untuk dipilih - ini hanya masalah apa yang Anda suka dan pilihan pembayaran apa yang ingin Anda lihat di BCW.Club.",
            para2:
              "Pemain selalu mencari sesuatu yang baru, yang akan membantu membuat pengalaman bermain menjadi jauh lebih baik dan lebih mudah diakses. Mengizinkan pemain untuk fokus pada kesenangan mutlak dari sebuah BCW.Club, itu benar, permainan itu sendiri.",
            leaveMessage: "tinggalkan pesan",
            getReward:
              "Sekarang dapatkan imbalan atas umpan balik Anda yang berharga.",
            placeHolder:
              "Menemukan bug?atau punya rekomendasi?sila tinggalkan pesan anda di sini .",
            feedbackSent: "Umpan balik berhasil dikirim.",
            feedbackErr: "Ada yang tidak beres, harap coba lagi.",
            emptyBox: "Kotak pesan tidak boleh kosong.",
          },
          footer: {
            acceptednetwork: "Jaringan yang diterrima",
            para: "Platform BCW.Club disukai dan dipercaya oleh jutaan pengguna di seluruh dunia. BCW.CLUB adalah BCW.Club crypto berbasis komunitas yang menawarkan pengalaman BCW.Club online terbaik kepada para pemainnya! Di BCW.CLUB, kami yakin bahwa blockchain akan mengubah industri perjudian crypto online selamanya! Masuk dan periksa sendiri! Bersenang-senang dan dapatkan kripto!",
          },
        },
      },
      ไทย: {
        translation: {
          header: {
            security2Fa: {
              security2FA: " ความปลอดภัย-2FA ",
              download: " ดาวน์โหลดและติดตั้ง ",
              downloadLink: "Google รับรองความถูกต้อง",
              downloadParaLeft:
                " เปิดใช้งานการรับรองความถูกต้องด้วยสองปัจจัย เพื่อปกป้องบัญชีของคุณ จากการเข้าถึงโดยไม่ได้รับอนุญาต.",
              scanQr:
                " สแกนรหัส QR ด้วยแอป Google รับรองความถูกต้อง หรือป้อนรหัสลับด้วย .",
              verificationCode: " รหัสยืนยัน ",
              yourSecretKey: " รหัสลับของคุณ ",
              enable2Fa: " เปิดใช้งาน 2FA ",
              disable2Fa: " ปิดการใช้งาน 2FA",
              para: " จดรหัสนี้ไว้ อย่าเปิดเผยให้คนอื่นรู้ คุณสามารถใช้มันเพื่อเข้าถึงบัญชีของคุณอีกครั้ง หากไม่มีการเข้าถึงตัวตรวจสอบสิทธิ์.",
            },
            banner: {
              refruend: " แนะนำเพื่อนเพื่อรับ ",
              comision: " ค่าคอมมิชชั่น 15% ",
              earn: " ลงทะเบียนและรับ ",
              term: " ข้อกำหนดและเงื่อนไขการอ้างอิง ",
              reward: " รับรางวัลผู้อ้างอิงของคุณ ",
              detail:
                " เพื่อนทุกคนที่คุณชวน จะได้เงิน ยิ่งชวนมาก ยิ่งได้มาก  แค่คุณชวนมาก คุณก็ได้มากเท่านั้น",
              rewardinpersent: "  รับรางวัลคอมมิชชัน 15% ของคุณ",
              resivedreward:
                "คุณจะได้รับรางวัลคอมมิชชั่นทุกครั้ง ที่เพื่อนของคุณวางเล่นตามเกม ทุกรอบ ",
              dashbord: " ไปที่แผงควบคุม ",
            },
            question: {
              qone: "ระบบอ้างอิงทำงานอย่างไร?",
              ansone:
                "เมื่อคุณแชร์ลิงก์ผู้แนะนำของคุณกับเพื่อน ครอบครัว หรือโฆษณา มีคนลงทะเบียนเพื่อเล่นที่ BCW.CLUB ผู้เล่นคนนั้นจะกลายเป็นผู้ที่คุณแนะนำและจะได้รับค่าคอมมิชชั่นและผลประโยชน์พิเศษ",
              qtwo: "ฉันสามารถหารายได้เท่าไหร่ จากการแนะนำเพื่อน",
              anstwo: "ต่อผู้อ้างอิง คุณจะได้รับ 15% * 1% ของเงินเล่น",
              qthre: "ฉันสามารถดูข้อมูลผู้อ้างอิงของฉันได้ไหม",
              ansthre:
                "ใช่ BCW.CLUB เชื่อมั่นในความโปร่งใสอย่างสมบูรณ์และให้ข้อมูลผู้ใช้ทั้งหมด รวมถึงชื่อผู้ใช้ การวางเล่นและค่าคอมมิชชันที่ได้รับ ทุกอย่างอยู่ในแดชบอร์ดพันธมิตรของคุณ",
              qfour: "ฉันจะติดตามจำนวนผู้เล่นที่ฉันแนะนำได้อย่างไร",
              ansfour:
                "คุณสามารถดูรายได้และสถิติอื่นๆ ของคุณผ่านแดชบอร์ดของโปรแกรมพันธมิตร",
              qfive: "มีตัวเลือกการชำระเงินใดบ้างสำหรับบริษัทในเครือ",
              ansfive:
                "รางวัลที่คุณได้รับจะอยู่ในรูปของ BCW ซึ่งเป็นเหรียญเกมอย่างเป็นทางการของเรา เหรียญ BCW สามารถแลกเปลี่ยนได้ด้วยสกุลเงินดิจิทัลที่รองรับบนแพลตฟอร์ม เมื่อคุณได้รับเงินจากการอ้างอิงแล้ว คุณสามารถเพิ่มลงในกระเป๋าเงินของคุณได้จากแดชบอร์ดพันธมิตร",
              qsix: "มีการสนับสนุนลูกค้าประเภทใดบ้าง ? สำหรับผู้เล่นเกมBCW.คลับออนไลน์",
              anssix:
                "BCW.CLUB มีทีมสนับสนุนลูกค้าโดยเฉพาะที่พร้อมช่วยเหลือผู้เล่นเมื่อมีคำถาม หรือปัญหาใดๆ ที่อาจมี ในฐานะพันธมิตร สิ่งสำคัญคือ ต้องโปรโมตเกมBCW.คลับออนไลน์คุณภาพสูง และเชื่อถือได้ซึ่งให้การสนับสนุนลูกค้าที่ยอดเยี่ยม.",
              qseven: "เกณฑ์การจ่ายเงินขั้นต่ำคือเท่าใด",
              ansseven:
                "เกณฑ์การจ่ายเงินขั้นต่ำคือจำนวนค่าคอมมิชชั่นขั้นต่ำที่คุณต้องได้รับก่อนที่คุณจะสามารถร้องขอการจ่ายเงินได้ ใน BCW.CLUB ไม่มีเกณฑ์ขั้นต่ำ คุณสามารถเรียกร้องรายได้ของคุณได้ตลอดเวลา",
            },
            signin: {
              signin: "เข้าสู่ระบบ",
              email: "อีเมล",
              loginPassword: "พาสเวิร์ด รหัส",
              forgotPass: "ลืมรหัส",
              directSignin: "หรือสมัครโดยตรงกับ",
              resetPass: "รีเซ็ตพาสเวิร์ส",
              enteremail: "กรอกอีเมล",
              enterpassword: "กรอกพาสเวิร์ส",
              emailaddress: "ที่อยู่อีเมล",
              haveAccount: "มีบัญชีอยู่แล้ว",
              register:"ที่อยู่อีเมลที่ลงทะเบียน"
            },
            signup: {
              signup: "เข้าสู่ระบบ",
              email: "ที่อยู่อีเมล",
              daily:"รายวัน",
              win:"ชนะ",
              spinthewheel:"หมุนวงล้อ",
              winfreecrypto:"รับรางวัล CRYPTO ฟรี!",
              enterpassword: " กรอกอีเมล",
              password: "รหัส",
              agreement:
                "ฉันเห็นด้วยกับข้อตกลงผู้ใช้ และยืนยันว่าฉันมีอายุอย่างน้อย 18 ปีแน่นอน",
              directSignup: "หรือสมัครโดยตรงกับ",
              editProfile: "แก้ไขโปรไฟล์",
              referralcode: "รหัสอ้างอิง",
              referral: " การอ้างอิง",
              enterrefcode: " ใส่รหัสอ้างอิงของคุณ",
              passwordrequired: "ต้องการรหัสผ่าน",
            },
            chat: {
              chat: "แชท",
              chatRules: "กฎการแชท",
              message: "ข้อความของคุณ",
              rule1:
                "ห้ามสแปม ก่อกวน หรือสร้างความไม่พอใจให้กับผู้ใช้รายอื่น นอกจากนี้ หลีกเลี่ยงการใช้ตัวพิมพ์ใหญ่! ไม่มีใครชอบที่จะถูกกรีดร้อง",
              rule2:
                "อย่าขอหรือขอสินเชื่อ หรือเรียกร้องใดๆ ทิป และเหรียญทวีคูณ",
              rule3: " ไม่มีพฤติกรรมที่น่าสงสัยที่อาจถูกมองว่าเป็นการหลอกลวง",
              rule4: "ห้ามโฆษณา/ซื้อขาย/ขาย/ซื้อหรือเสนอบริการในรูปแบบใดๆ",
              rule5: "อย่าใช้ตัวย่อ URL ส่งลิงก์ต้นฉบับเสมอ",
              rule6: "ใช้ห้องสนทนาภาษาที่กำหนดตามนั้น",
              global: "ทั่วโลก",
            },

            referral: {
              spin: "สปิน",
              menu: "เมนู",
              ern: "ได้รับ",
              crypto: "คริปโต",
              cardnumber:"หมายเลขบัตร / หมายเลขบัญชี",
              fiat: "เฟียต",
              hidempty: "ซ่อนความว่างเปล่า",
              search: "ค้นหา",
              chtroom: "ห้องสนทนา",
              earn: "หมุนและรับ",
              dashbord: " ไปที่แผงควบคุม",
              question: "คำถามที่พบบ่อย",
              Affiliate: "พันธมิตร",
              Crash: " ชน",
              rerearn: "อ้างอิงและรับ",
              userinfo: "ข้อมูลผู้ใช้",
              bcs: "BCSwap",
              tot: "ทั้งหมด",
              trans: "ธุรกรรม",
              stat: "สถิติ",
              earn: "หมุนและรับ",
              free: "ถัดไป ฟรี",
              vip: "สิทธิพิเศษวีไอพีของฉัน",
              rerearn: "อ้างอิงและรับ",
              alplyer: "ผู้เล่นทั้งหมด",
              Logout: "ออกจากระบบ",
              Casino: "BCW.คลับ",
              Casno: "BCW.คลับ",
              BCWOriginals: "ต้นฉบับ BCW",
              Promo: "โปรโมชั่น",
              TotalEarned: "รางวัลรวมที่ได้รับ",
              TotalFrReferred: "เพื่อนทั้งหมดที่ได้รับการแนะนำ",
              Referfriend: " แนะนำเพื่อน",
              userId: "รหัสผู้ใช้",
              username: "ชื่อผู้ใช้",
              totacommission: "ค่าคอมมิชชั่น",
              totalwager: " เล่นทั้งหมด",
              shareyourreferralink: "แบ่งปันลิงค์อ้างอิงของคุณ",
              claimed: "อ้างสิทธิ์",
              update: "อัพเดต",
              referralmanagement: "การจัดการการอ้างอิง",
              totalFriendsreferred: "เพื่อนทั้งหมดที่ได้รับการแนะนำ",
              claimnow: "เรียกร้องตอนนี้",
              oop: "ยังไม่มีข้อมูล",
              bankroll: " ธนาคาร",
              Notclaimed: "ไม่อ้างสิทธิ์",
              mores: "อื่นๆ",
              notes: "สังเกต",
              fee: "ค่าธรรมเนียม",
              invalidAmount: "จำนวนเงินไม่ถูกต้อง",
              currencynotavailable:"ไม่มีสกุลเงิน โปรดเลือกอื่น ๆ",
            },
            span: {
              wheel: "วงล้อรางวัล ",
              spannow: "หมุนตอนนี้",
            },
            wallet: {
              name: "ชื่อ",
              wallet: "กระเป๋าสตางค์",
              deposit: "เงินฝาก",
              buy: "ซื้อ",
              maxamount:"จำนวนเงินสูงสุดควรเป็น",
              minamount:"จำนวนเงินขั้นต่ำควรเป็น",
              vault: "ห้องนิรภัย",
              swap: "แลกเปลี่ยน",
              toppay: "ท็อปเพย์",
              confirm: "ยืนยัน",
              safty:
                "เปลี่ยนเส้นทางไปยังหน้าฝากเงิน สนับสนุนโดยผู้ให้บริการที่เป็นทางการและเชื่อถือได้ของ BCW .Club",
              safety:
                "สำหรับคำถามใด ๆ โปรดติดต่อฝ่ายสนับสนุนตลอด 24 ชั่วโมงของเรา",
              metod: "เลือกวิธีการชำระเงิน",
              bankdeposit: "เงินฝาก Fiat - โอนเงินผ่านธนาคาร",
              bankwithdraw: "Fiat ถอน - โอนเงินผ่านธนาคาร",
              accountholder: "ผู้ถือบัญชี",
              bankname: "ชื่อธนาคาร",
              crypto: "คริปโต",
              bankaccount: "บัญชีธนาคาร",
              idcard: "บัตรประจำตัวประชาชน",
              phone: "โทรศัพท์",
              withdraw: "ถอน",
              transaction: "ธุรกรรม",
              secureAsset: "เพื่อรักษาทรัพย์สินของคุณ",
              please: "กรุณา",
              enableFa: "เปิดใช้งาน 2FA",
              disableFa: "ปิดการใช้งาน 2Fa",
              mostpara:
                "ส่วนที่น่าตื่นเต้นที่สุดของการชุบที่ Crypto การเล่นเกม คือโบนัสที่มีให้! BCW.CLUB แพลตฟอร์มการเล่นเกม Crypto ชั้นนำของโลกมอบโบนัสเงินฝากที่คุ้มค่าแก่คุณ ผู้เล่นที่ภักดีของเรา ไม่ใช่ 1 แต่ 4 โบนัสเงินฝาก",
              mostparaone:
                " ส่วนที่ดีที่สุดเกี่ยวกับการมี 4 โบนัสคือคุณสามารถเพลิดเพลินกับการเล่นเกม Crypto ออนไลน์ด้วยความช่วยเหลือจาก Crypto การเล่นเกม ที่เป็นมิตรและให้รางวัลมากที่สุด! ไม่มีโบนัสเงินฝากเหมือนของ BCW.CLUB โดยมียอดรวมเงินฝากมากถึง 1,050%",
              notonly:
                "ไม่เพียงแต่เป็นเวลาที่สมบูรณ์แบบในการสร้าง Crypto พิเศษเท่านั้น แต่ยังเป็นโอกาสของคุณที่จะได้รับเหรียญ Crypto ของเราเอง BCW coin (BCW) คุณจะได้รับรางวัลเป็น BCW สำหรับเงินฝากของคุณเพื่อใช้ตามดุลยพินิจของคุณ",
              fristdeposit: "โบนัสเงินฝากครั้งที่ 1",
              secondbon: "โบนัสเงินฝากครั้งที่ 2",
              thirdbon: "โบนัสเงินฝากครั้งที่ 3",
              fourthbon: "โบนัสเงินฝากครั้งที่ 4",
              fristbonce:
                " ยินดีต้อนรับสู่ BCW.CLUB ปลายทางชั้นนำสำหรับทุกความต้องการของ Crypto BCW.Clubของคุณ! เรารู้สึกตื่นเต้นที่จะเสนอการจับคู่เงินฝากขนาดใหญ่ 250% สูงถึง 20,000BCW เมื่อคุณทำการฝากเงินครั้งแรกในวันนี้ นี่เป็นโอกาสของคุณที่จะเพิ่มประสบการณ์การเล่นเกมและรับรางวัลใหญ่ อย่าพลาดโอกาสอันเหลือเชื่อนี้!  ด้วยจำนวนเงินเติมขั้นต่ำเพียง 30 USD คุณสามารถเริ่มเล่นและรับ BCW ได้ในเวลาไม่นาน ดังนั้นสิ่งที่คุณรอ?  เล่นทันทีและเริ่มชนะ เริ่มเลยสิ",
              seconddep:
                "ยินดีด้วย! คุณได้ก้าวไปสู่การเดินทางครั้งยิ่งใหญ่ของ Crypto BCW.Clubแล้ว และเราตื่นเต้นที่จะตอบแทนความภักดีของคุณ ด้วยการจับคู่เงินฝาก 250% ที่น่าทึ่ง สูงถึง 40,000BCW ในการฝากครั้งที่สองของคุณ ที่ BCW.CLUB เราเชื่อในการมอบสิ่งที่ดีที่สุดให้กับผู้เล่นของเรา และโบนัสนี้ก็ไม่มีข้อยกเว้น ด้วยจำนวนเงินเติมขั้นต่ำ 60 USD คุณสามารถเพลิดเพลินกับความสนุกในการเล่นเกมไม่รู้จบและรับ BCW มากยิ่งขึ้น เอาเลย ใช้ประโยชน์จากข้อเสนอนี้และปล่อยให้ช่วงเวลาดีๆ หมุนไป",
              thirddep:
                " BCW.CLUB กลับมาพร้อมกับอีกหนึ่งข้อเสนอสุดพิเศษที่จะทำให้คุณทึ่ง! ฝากเงินขั้นต่ำและรับการจับคู่เงินฝาก 250% ที่น่าทึ่ง สูงถึง 60,000BCW ในการฝากครั้งที่สามของคุณ ใช่ คุณอ่านถูกแล้ว! นี่เป็นโอกาสของคุณที่จะยกระดับประสบการณ์การเล่นเกมของคุณไปอีกขั้นและรับรางวัลใหญ่ และด้วยจำนวนเงินเติมขั้นต่ำเพียง 120 USD ข้อเสนอนี้ดีเกินกว่าจะปล่อยผ่านไป ดังนั้นสิ่งที่คุณรอ? ฝากตอนนี้และเริ่มชนะ",
              fourthdep:
                " คุณพร้อมสำหรับสุดยอดการผจญภัยของ Crypto BCW.Clubแล้วหรือยัง? ไม่ต้องมองหาที่อื่นนอกจาก BCW.CLUB! เป็นของขวัญพิเศษจาก BCW เราขอเสนอการจับคู่เงินฝาก 300% ที่ไม่เคยมีมาก่อน สูงถึง 100,000BCW ในการฝากเงินครั้งที่สี่ของคุณ ถูกต้อง - โบนัสนี้แทบไม่เคยได้ยินมาก่อนในพื้นที่การเล่นเกม Crypto! ด้วยจำนวนเงินเติมขั้นต่ำ 150 USD คุณสามารถเพิ่มเงินรางวัลและเพิ่มประสบการณ์การเล่นเกมของคุณไปอีกขั้น ดังนั้นอย่ารอช้าอีกต่อไป รับโบนัสของคุณวันนี้และปล่อยให้ช่วงเวลาดีๆ หมุนไป",
              back: "กลับ",
              depositTab: {
                depositCurrency: "สกุลเงินฝาก",
                record: "บันทึก",
                chooseNetwork: "เลือกเครือข่าย",
                depositAddress: "ที่อยู่ฝาก",
                balance: " สมดุล",
                copy: "สำเนา",
                copied: "คัดลอก",
                notice: "สังเกต",
                note: "ส่งเฉพาะ ETH ไปยังที่อยู่เงินฝากนี้ เหรียญจะถูกฝากโดยอัตโนมัติหลังจากการยืนยันเครือข่าย 6 ครั้ง ไม่รองรับที่อยู่สัญญาอัจฉริยะ (ติดต่อเรา)",
              },
              swapTab: {
                getApprox: " คุณได้รับโดยประมาณ",
                record: "บันทึก",
                swapFee: "ค่าธรรมเนียมการแลกเปลี่ยน",
                fee: "ค่าธรรมเนียม",
                swaped: " เปลี่ยน",
                swapNow: "เปลี่ยนเลย",
                invalidAmount: "จำนวนเงินไม่ถูกต้อง",
                success: "สำเร็จ",
                fail:"ล้มเหลว",
                swapSuccess: "สลับสำเร็จ",
                topup:"เติมเงินในกระเป๋าเงินของคุณหรือลดจำนวนสวอป",
                max: "สูงสุด",
                send: "ส่ง",
                get: " รับ",
              },
              withdrawTab: {
                chooseNetwork: "เลือกเครือข่าย",
                balance: "Balance",
                withdrawAddress: "ถอนที่อยู่",
                addressPlaceholder: "กรอกอย่างระมัดระวังตามสกุลเงินที่ระบุ",
                notificationalret:
                  "ระหว่างการบำรุงรักษา โปรดเลือกเครือข่ายอื่นสำหรับการถอน",
                undermatainance: "ภายใต้การบำรุงรักษา",
                withdrawAmount: "จำนวนเงินที่ถอนออก",
                receive: "คุณจะได้รับ",
                amountPlaceholder: "ใส่จำนวนเงินที่จะถอน",
                min: "นาที",
                securityPurpose:
                  "เพื่อความปลอดภัย การถอนเงินจำนวนมากหรือน่าสงสัยอาจใช้เวลา 1-6 ชั่วโมงสำหรับกระบวนการตรวจสอบ ขอขอบคุณสำหรับความอดทนของคุณ",
                inProgress: "กำลังดำเนินการถอนเงิน",
                pendingApproval: "การถอนกำลังรอการอนุมัติ",
                frozenAssets: "ไม่สามารถถอนได้เนื่องจากสินทรัพย์ถูกแช่แข็ง",
                noGamePlayed: "ไม่สามารถถอนได้เนื่องจากจำนวนเกมที่เล่นเป็น 0",
                lowBalance: " ไม่สามารถถอนได้เนื่องจากยอดเงินคงเหลือน้อย",
              },
              transactionTab: {
                deposit: "เงินฝาก",
                withdraw: "ถอน",
                bill: "ใบแจ้งหนี้",
                bilswap: "ใบแจ้งหนี้/แลกเปลี่ยน",
                all: "ทั้งหมด",
                time: " เวลา",
                amount: "จำนวน",
                balance: "สมดุล",
                status: "สถานะ",
                transaction: " ธุรกรรม",
                depositSuccessfull: "ฝากเงินสำเร็จ",
                adminDeposit: "ฝากแอดมิน",
                details: "รายละเอียด",
                orderId: "รหัสคำสั่งซื้อ",
                currency: "โซ่",
                quantity: " ปริมาณ",
                successfull: "ประสบความสำเร็จ",
                unsuccessfull: "ไม่สำเร็จ",
                withdrawing: "การถอน",
                processing: "กำลังประมวลผล",
                pending: "รอดำเนินการ",
                type: "พิมพ์",
                swap: "แลกเปลี่ยน",
                swapSend: " สลับส่ง",
                swapGet: "รับแลก",
              },
            },
            userProfile: {
              frontPage: {
                userInformation: "ข้อมูลผู้ใช้",
                userId: "ไอดีผู้ใช้",
                statistics: "สถิติ",
                totalWins: "ชนะทั้งหมด",
                totalBets: " เล่นทั้งหมด",
                totalWagered: " เล่นทั้งหมด ",
                joinAt: "เข้าร่วมเมื่อ",
                editProfile: "แก้ไขโปรไฟล์",
              },
              editPage: {
                nickname: "ชื่อเล่น",
                username: "ชื่อผู้ใช้",
                editMyProfile: "แก้ไขโปรไฟล์ของฉัน",
                updateMyPassword: "อัพเดตรหัสของฉัน",
                usernamePlaceholder: "ป้อนชื่อผู้ใช้ของคุณ",
                doNotUse:
                  "อย่าใช้เครื่องหมายวรรคตอนพิเศษ มิฉะนั้น บัญชีของคุณอาจไม่ได้รับการสนับสนุน",
                fName: "ชื่อจริง",
                lName: "นามสกุล",
                signinEmail: "ลงชื่อเข้าใช้อีเมล",
                emailPlaceholder: "กรอกอีเมล",
                emailchangeError: "ไม่สามารถเปลี่ยนอีเมลได้",
                modify: "แก้ไข",
                enteryremail: "กรอกอีเมล์ของคุณ",
                validEmail:
                  "โปรดป้อนอีเมลที่ถูกต้อง มิฉะนั้น คุณจะไม่สามารถยืนยันบัญชีของคุณได้",
                verifiedEmail: "ยืนยันอีเมลแล้ว",
                notVerifiedEmail: "อีเมลไม่ได้รับการยืนยัน",
                sendVerificationLink: "ส่งลิงค์ยืนยัน",
                verificationLinkSent: "ส่งลิงค์ยืนยันแล้ว",
                showPass: "แสดงรหัสผ่าน",
                hidePass: "ซ่อนรหัสผ่าน",
                currentPassword: "รหัสผ่านปัจจุบัน",
                currentPassPlaceholder: "ป้อนรหัสผ่านปัจจุบันของคุณ",
                newPass: "รหัสผ่านใหม่",
                newPassPlaceholder: "ป้อนรหัสผ่านใหม่ของคุณ",
                confirmPass: "ยืนยันรหัสผ่าน",
                confirmPassPlaceholder: "ยืนยันรหัสผ่านของคุณ",
                passLength: "ความยาวขั้นต่ำของรหัสผ่านควรเป็น 6 หรือมากกว่า",
                passEquality: "รหัสผ่านใหม่ควรเท่ากับการยืนยันรหัสผ่าน",
                invalidCurrent: "รหัสผ่านปัจจุบันไม่ถูกต้อง",
                emailChangeSuccess: "เปลี่ยนอีเมลเรียบร้อยแล้ว",
              },
            },
            bcwModal: {
              bcwUnlock: "ปลดล็อค Bcw",
              howToUnlock: "วิธีปลดล็อก",
              amountUnlockable: "กระสุนปลดล็อค",
              unlocked: "ปลดล็อค",
              claim: "เรียกร้อง",
              unlock: "ปลดล็อค",
              wager: " เล่น",
              minRequireToClaim: " ขั้นต่ำที่จำเป็นในการเรียกร้อง",
              bcwRecord: "บันทึก BCW",
              totalClaimed: "อ้างสิทธิ์ทั้งหมด",
              date: " วันที่",
              type: "พิมพ์",
              amount: "จำนวน",
              deposit: "เงินฝาก",
              claimed: "อ้างสิทธิ์",
              spinWheel: " ล้อหมุน",
              aboutBcw: "เกี่ยวกับ Bcw",
              bcwUnlock: "ปลดล็อค BCW",
              whatBcw: " BCW คืออะไร ",
              paraWhatBcw:
                "BCW (BCW Coin) เป็นสกุลเงินพิเศษที่เปิดตัวโดย BC.GAME 1 BCW = 1 เหรียญสหรัฐ คุณสามารถเล่นเกม ให้ทิป หยอดเหรียญ และฝนกับ BCW",
              howToUnlock: "วิธีปลดล็อก BCW",
              hotToUnlockPara:
                "Locked BCW ได้จากโบนัสบางอย่าง เช่น โบนัสเงินฝากและการหมุนนำโชค การปลดล็อก BCW นั้นง่ายมาก! โดยพื้นฐานแล้วมันเหมือนกันกับ rakeback และจะปลดล็อกตามสัดส่วนผ่านการ เล่น",
              unlockAmount: "ปลดล็อคจำนวนเงิน",
              wagerAmount: "จำนวนเงิน เล่น",
              howToClaim: "วิธีขอรับสิทธิ์ปลดล็อก BCW",
              hotToClaimPara:
                "เมื่อคุณ เล่น กล่องสมบัติ BCW ของคุณจะเต็มไปด้วย BCW ที่ปลดล็อค เมื่อคุณเติมกล่องสมบัติของคุณอย่างน้อย 10BCW ให้คลิก 'อ้างสิทธิ์' และ BCW ที่ปลดล็อคจะถูกโอนไปยังยอดคงเหลือ BCW ของคุณโดยตรง แค่นั้นแหละ! BCW ของคุณพร้อมใช้งานทันที",
              exchangeBcw: "BCW สามารถแลกเปลี่ยนเป็นสกุลเงินอื่น ๆ ได้หรือไม่",
              exchangeBcwPara:
                "แน่นอน! สิ่งที่น่าตื่นเต้นที่สุดคือมูลค่าของ 1 BCW จะผูกไว้กับราคา 1 USDT และคุณสามารถสลับ BCS BCW เป็นสกุลเงินอื่นได้ตลอดเวลา",
            },
          },
          allbets: {
            player: "ผู้เล่น",
            betting: "กำลังเล่น",
            cashout: "เงินออก",
            amount: "จำนวน",
            profit: "โปรไฟล์",
          },
          gamebox: {
            graphbar: {
              bankroll: "ธนาคาร",
              trends: "กราฟ ประวัติ",
              understandingchart: "ทำความเข้าใจเกี่ยวกับแผนภูมิแนวโน้ม",
            },
            graph: {
              connecting: "เชื่อมต่อ",
              youWon: " คุณได้รับรางวัล",
              startsin: "เริ่มเข้า",
              bang: "แตก",
            },
            betit: {
              amount: "จำนวน",
              autocashout: "เอาเงินออก อัตโนมัติ",
              placebet: "เล่น",
              loading: "กำลังโหลด",
              cancel: "ยกเลิก",
              nextround: "รอบต่อไป",
              payout: "การจ่ายเงิน",
              min: " นาที",
              max: "สูงสุด",
            },
            modals: {
              helpmodal: {
                help: "ช่วยเหลือ",
                whatGame: "นี่คือเกมอะไร",
                fairness: " ความเป็นธรรม",
                bankroll: "ธนาคาร",
                autoCashout: "เงินสดออกอัตโนมัติ",
                whatGameSection: {
                  whatThisGame: "นี่คือเกมอะไร",
                  whatCrash: "ความผิดพลาดคืออะไร",
                  whatCrashPara:
                    "ความผิดพลาด เป็นเกมที่มีผู้เล่นหลายคนซึ่งคุณได้รับอนุญาตให้ถอนเงินหลังจาก เล่น จำนวนเงินที่คุณจะได้รับจะขึ้นอยู่กับจำนวนผู้เล่นที่ เล่นในรอบนั้น",
                  howToPlay: "วิธีเล่น",
                  howToPlayPara:
                    "ก่อนที่เกมจะเริ่มต้น คุณจะมีเวลา 6 วินาทีในการวาง เล่นของคุณ หลังจากที่เกมเริ่มต้นแล้ว ตัวคูณจะเพิ่มขึ้นเรื่อยๆ เริ่มต้นจาก 1 เท่า (1X) คุณสามารถคลิกที่ Cash Out ได้ทุกเมื่อเพื่อล็อคตัวคูณปัจจุบันและปลดล็อคการจ่ายเงินของคุณ ซึ่งจะเท่ากับการ เล่นของคุณคูณด้วยตัวคูณปัจจุบัน ยิ่งคุณอยู่ในเกมนานเท่าไร ค่าการจ่ายเงินของคุณก็จะสูงขึ้นเรื่อยๆ โปรดทราบว่า แต่ละรอบการเล่นมีโอกาสเกิดเหตุการณ์ Curve Crash ได้ทุกเมื่อ หากคุณไม่ทำการ Cash Out ก่อน Curve Crash เกิดขึ้น คุณจะสูญเสียเงิน เล่นทั้งหมดของคุณ คุณจะเลือกที่จะ Cash Out ที่ 1.01x หรือคุณจะเล่นไปจนถึง 100x หรือ 1000x หรือ 10000x ... อย่างเพลิดเพลิน เป็นเรื่องของคุณ - แต่คุณต้องตัดสินใจแบบด่วนด้วยเวลาจำกัด! (เกมนี้ไม่เหมาะสำหรับคนที่มีหัวใจอ่อน)",
                },
                fairnessSection: {
                  fairness: "ความเป็นธรรม",
                  isFair: "เกมนี้ยุติธรรมหรือไม่",
                  isFairPara:
                    "เราเป็นแพลตฟอร์มการทำนายและคาดเดาที่ยุติธรรมและเป็นกลาง เป้าหมายของเราคือการกำจัดปัจจัยที่ไม่ยุติธรรมทั้งหมดและทำให้ผู้เล่นรู้สึกสบายใจและสนุกสนาน เราได้สร้างแฮชทั้งหมด 10 ล้านแฮช (ห่วงโซ่การสร้างสามารถตรวจสอบได้) และแฮชแต่ละอันสอดคล้องกับตัวคูณการชนของเส้นโค้ง เราปล่อยตัวเลข 10 ล้านเหล่านี้ตามลำดับย้อนกลับ โดยแต่ละหมายเลขสอดคล้องกับหนึ่งเทิร์นของเกม (เช่น เรามีทั้งหมด 10 ล้านเทิร์น) กล่าวอีกนัยหนึ่ง จำนวนความผิดพลาดของแต่ละเทิร์นมีอยู่แล้วและไม่ได้คำนวณหลังจากเริ่มเกม ผู้เล่นจึงสามารถวาง เล่นได้โดยไม่ต้องกังวล",
                  manipulation: "เกมจะถูกจัดการโดยแพลตฟอร์มหรือไม่",
                  hashVerify: "ตรวจสอบแฮช",
                  manipulationPara1:
                    "ค่าการตรวจสอบความสมบูรณ์เป็นกุญแจสำคัญในการตรวจสอบว่ามีการบิดเบือนอย่างเป็นทางการหรือไม่ อัลกอริทึมการทดสอบมีดังต่อไปนี้",
                  example: "ตัวอย่าง",
                  manipulationPara2:
                    "1 : ใช้ค่าสุ่มในช่วง 2^52 คือ 16^13 เช่น เลขฐานสิบหก 13 บิต (เนื่องจากค่าแฮชเป็นเลขฐานสิบหก 2^52 === 16^13)6b5124897c3c4 (0x6b5124897c3c4 เท่ากับ 1887939992208324",
                  manipulationPara3:
                    "2 : กระจายค่าสุ่มเป็น 0~1 โดยหารด้วยค่าสูงสุด 13 fs คือ 0x6b5124897c3c4/0x10000000000000 เมื่อพิจารณาถึงลักษณะสุ่มแบบไม่ต่อเนื่องของค่าแฮช เราจึงคิดได้ว่าค่าแฮชใดๆ สามารถแปลงเป็น ตัวเลขสุ่ม 0~1,",
                  manipulationPara4:
                    "3 : ทำให้เจ้ามือได้เปรียบ 1% นอกจากนี้ในการคำนวณ 99/(1-X) โดยที่ X คือค่าสุ่มที่คำนวณในขั้นตอนที่ 2 เมื่อ X เป็น 0 ผลลัพธ์คือ 99 เมื่อ X เป็น 1 ผลลัพธ์คือ บวกอนันต์ เมื่อ X เป็น 0.01 ผลลัพธ์คือ 100 เมื่อ X น้อยกว่า 0.01 ผลลัพธ์จะน้อยกว่า 100 สรุป: การกระจายตัวเลขสุ่มโดยรวมคือ 99 ถึงบวกอนันต์ และเมื่อการกระจายตัวเลขสุ่มคือ 0~0.01 , ผลลัพธ์น้อยกว่า 100 99/(1-0.419206889692064) = 170.45656748150867",
                  manipulationPar5:
                    "4 : ค่าทั้งหมดที่น้อยกว่า 100 จะถูกตั้งค่าเป็น 100 กล่าวคือ มีความน่าจะเป็น 1% ที่ 100 จะปรากฏขึ้น ปัดตัวเลขแล้วหารด้วย 100 เพื่อให้ได้ผลลัพธ์สุดท้าย 170/100 = 1.70 สรุป: ค่าแฮชที่ใช้ในเกมจะเรียงลำดับผกผัน ดังนั้น ด้วยอัลกอริทึม SHA256 แฮชก่อนหน้าที่ใช้ในเกมสามารถคำนวณได้จากแฮชที่ตามมา เนื่องจากคีย์และค่ามีความสอดคล้องกันแบบหนึ่งต่อหนึ่ง ของแฮช เราสามารถสรุปได้ว่าหากสามารถใช้แฮชในการคำนวณแฮชที่อยู่ก่อนหน้าได้ ดังนั้น แฮชนี้ควรจะถูกสร้างขึ้นแล้วเมื่อมีการประกาศรางวัลก่อนหน้า ในทำนองเดียวกัน ห่วงโซ่แฮชทั้งหมดจะถูกสร้างขึ้นตั้งแต่เริ่มต้น และไม่สามารถเปลี่ยนแปลงได้เมื่อสร้างแล้ว มิฉะนั้น จะไม่สามารถผ่านการตรวจสอบโดย SHA256 และเท่าที่เกี่ยวข้องกับการจ่ายเงิน เกมนี้ไม่มีอะไรมากไปกว่าเกมความน่าจะเป็นที่เกมจะได้รับ Crash ผู้จัดงานอย่างเป็นทางการไม่สามารถควบคุมชุดเกมใดๆ ได้ ดังนั้น , CRASH มีความโปร่งใสมากขึ้น ฮันวิธีการเล่นเกมอื่น ๆ นี่คือรากฐานที่สำคัญในการสร้างเกมของเรา การคำนวณอย่างง่าย: เมื่อค่าแฮช 13 บิตคือ 8000000000000 = 1.98, 0xb000000000 = 3.168, 0xc000000000 = 3.96 นั่นคือ หลักแรกมากกว่า 8((16-8)/16≈0.5) ผลลัพธ์จะอยู่ที่ประมาณ 2x ; เมื่อตัวเลขตัวแรกมากกว่า b((16-11)/16≈0.3) ผลลัพธ์จะอยู่ที่ประมาณ 3x; และเมื่อตัวเลขตัวแรกมากกว่า c((16-12)/16≈0.25) ผลลัพธ์จะอยู่ที่ประมาณ 4x และจะใช้กฎเดียวกันนี้กับส่วนที่เหลือ เมื่อค่าแฮช 13 บิตคือ f000000000000 = 15.84, ff00000000000 = 253.44, fff000000",
                },
                bankrollSection: {
                  bankroll: "ธนาคาร",
                  whatBankroll: "แบ๊งค์คืออะไร",
                  bankrollPara:
                    "แบ๊งค์คือกองกลางของเงินที่แบ๊งค์ใช้เพื่อจ่ายให้กับผู้ชนะของเกม กำไรสูงสุดที่ผู้เล่นสามารถชนะจากรอบของเกมจะพิจารณาจากขนาดของแบ๊งค์ ยิ่งแบ๊งค์มากเท่าไหร่ ผู้เล่นก็ยิ่งชนะมากขึ้นเท่านั้น ผู้เล่นแต่ละคนสามารถชนะได้เพียง 0.75% ของแบ๊งค์ต่อรอบ ผู้เล่นทุกคนสามารถชนะได้เพียง 1.125% ของเงินทุนต่อรอบ ผู้เล่นสามารถ เล่นในแบ๊งค์ (เช่น กลายเป็นแบ๊งค์) และ เล่นของพวกเขาจะถูกเพิ่มเข้าไปในแบ๊งค์เพื่อให้พวกเขาชนะเมื่อ บ้านชนะและพวกเขาแพ้เมื่อบ้านแพ้",
                  poolFunds: "กองทุนรวมทำงานอย่างไร",
                  poolFundsPara:
                    "แบ๊งค์ใช้ระบบการถือหุ้นที่อนุญาตให้ทุกคนมีส่วนร่วมและรับหุ้นที่สอดคล้องกัน",
                  houseEdge: "ขอบบ้านคือ 1%",
                  poolFundsParaLeft:
                    "99% ของการ เล่นแต่ละครั้งจะไปที่แบ๊งค์ และ 1% ที่เหลือจะถูกสงวนไว้สำหรับค่าใช้จ่ายในการดำเนินการแพลตฟอร์ม การจ่ายเงินให้กับผู้เล่นที่ชนะจะถูกหักออกจากแบ๊งค์",
                  maxProfit: "กำไรสูงสุด",
                  maxProfitPara:
                    "เมื่อกำไรจากการ เล่นของคุณเกินกำไรสูงสุด ระบบจะปรับเป็นกำไรสูงสุดโดยอัตโนมัติ สกุลเงินต่างๆ มีกำไรสูงสุดต่างกันดังนี้",
                },
                autoCashoutSection: {
                  auto: "เงินสดออกอัตโนมัติ",
                  internetLag: "เหตุใดจึงมีความล่าช้าของอินเทอร์เน็ต",
                  internetLapPara:
                    "เนื่องจาก CRASH เป็นเกมออนไลน์แบบเรียลไทม์ (เกมที่ลูกค้าโต้ตอบกับเกมผ่านทางอินเทอร์เน็ต) จึงมีความล่าช้าระหว่างเวลาที่คุณคลิกที่ปุ่มแลกเงินกับเวลาที่เซิร์ฟเวอร์ได้รับคำแนะนำในการถอนเงินของคุณ ยิ่งคุณอยู่ห่างจากเซิร์ฟเวอร์และการเชื่อมต่ออินเทอร์เน็ตของคุณยิ่งแย่ ข้อความของคุณก็จะยิ่งใช้เวลานานขึ้นในการเข้าถึงเซิร์ฟเวอร์เกม ในสภาพแวดล้อมที่สมบูรณ์แบบ ข้อความของคุณสามารถเดินทางไปยังเซิร์ฟเวอร์ด้วยความเร็วแสง แต่ก็ยังใช้เวลา 134 มิลลิวินาทีในการเดินทางรอบโลก",
                  autoCashout: "การใช้เงินสดออกอัตโนมัติคืออะไร",
                  autoCashuotPara:
                    " วิธีที่ดีที่สุดในการหลีกเลี่ยงความเสียหายที่เกิดจากความล่าช้าของอินเทอร์เน็ตคือการใช้ฟังก์ชันถอนเงินอัตโนมัติ เนื่องจากการถอนเงินอัตโนมัติของคุณจะถูกส่งไปยังเซิร์ฟเวอร์ในเวลาเดียวกันเมื่อคุณวาง เล่น เซิร์ฟเวอร์สามารถดำเนินการตามคำแนะนำในการถอนเงินของคุณได้อย่างแม่นยำและไม่คำนึงถึงความล่าช้า ตัวอย่างเช่น หากการเชื่อมต่อของคุณไม่ดีและคุณต้องการถอนเงินที่ 2x เราขอแนะนำให้คุณตั้งค่าการถอนเงินอัตโนมัติเป็น 2 เท่า แทนที่จะจ่ายออกด้วยตนเองที่ 2 เท่า เพราะหลังจากที่คุณคลิก 'ถอนเงิน' เส้นโค้งอาจขัดข้องก่อนที่ข้อความของคุณจะไปถึงเซิร์ฟเวอร์",
                  acciedentlyDisconnected:
                    "คุณควรทำอย่างไรหากเกมขาดการเชื่อมต่อโดยไม่ตั้งใจ",
                  acciedentlyDisconnectedPara:
                    "เมื่อเราสังเกตเห็นว่าคุณถูกตัดการเชื่อมต่อจากเกมที่ใช้งานอยู่ เราจะพยายามจ่ายเงินให้คุณ อย่างไรก็ตาม เราขอแนะนำให้คุณใช้ฟังก์ชันการถอนเงินอัตโนมัติเพื่อจัดการกับปัญหานี้ เนื่องจากตัวคูณการถอนเงินอัตโนมัติของคุณถูกส่งไปยังเซิร์ฟเวอร์แล้ว คุณจึงยังสามารถถอนเงินออกได้ตามปกติแม้ว่าคุณจะไม่ได้เชื่อมต่อกับระบบก็ตาม นี่เป็นวิธีที่น่าเชื่อถือที่สุดในการหลีกเลี่ยงความเสียหายที่เกิดจากการตัดการเชื่อมต่อโดยไม่ตั้งใจ",
                },
              },
              keysmodal: {
                hotkeys: "ปุ่มลัด",
                half: "จำนวนเงิน เล่นครึ่งหนึ่ง",
                double: "จำนวนเงิน เล่นสองเท่า",
                betoperation: "วาง เล่น | เงินออก",
              },
            },
          },
          stats: {
            mybetstxt: "บทละครของฉัน",
            historytxt: "ประวัติ",
            highrollerstxt: "ลูกกลิ้งสูง",
            mybets: {
              betid: "เล่นไอดี",
              bet: "เล่น",
              time: "เวลา",
              payout: "การจ่ายเงิน",
              profit: "กำไร",
            },
            history: {
              gameid: "ไอดีเกม",
              result: "ผลลัพธ์",
              hash: "การสับ",
              verify: "ตรวจสอบ",
            },
            highrollers: {
              player: "ผู้เล่น",
              betamount: "จำนวน เล่น",
              multiplier: "ตัวคูณ",
              profitamount: "จำนวนกำไร",
            },
          },
          feedback: {
            heading1: "BCW.คลับออนไลน์ คริปโต",
            formTitle: "ช่วยเราปรับปรุงประสบการณ์ของคุณ",
            para1:
              "BCW.คลับออนไลน์ไม่ได้มีอยู่ทั่วไป แต่เราสามารถพูดได้อย่างปลอดภัยว่าBCW.คลับออนไลน์ถูกนำมาใช้มากมายตั้งแต่เข้ามาในตลาด และไม่ใช่อุปสงค์หรือตัวเลือกที่ขาดตลาด และตอนนี้ในปี 2022 เรามี 1,000 และ 1,000 ให้เลือก - เป็นเรื่องของสิ่งที่คุณชอบและตัวเลือกการชำระเงินที่คุณต้องการดูที่BCW.คลับ",
            para2:
              "ผู้เล่นมักจะมองหาสิ่งใหม่ๆ อยู่เสมอ ซึ่งจะช่วยให้ประสบการณ์การเล่นเกมดีขึ้นมากและเข้าถึงได้มากขึ้น ทำให้นักพนันสามารถมุ่งความสนใจไปที่ความสนุกของBCW.คลับได้อย่างแน่นอน นั่นก็คือ เกมส์นั่นเอง",
            leaveMessage: "ฝากข้อความ",
            getReward: "ตอนนี้รับรางวัลสำหรับความคิดเห็นที่มีค่าของคุณ",
            placeHolder:
              "หากคุณพบข้อบกพร่องหรือปัญหาในการใช้งาน โปรดแจ้งให้เราทราบ ฝากข้อความไว้ที่นี่",
            feedbackSent: "ส่งฟีดแบ็คเรียบร้อยแล้ว",
            feedbackErr: "เกิดข้อผิดพลาด โปรดลองอีกครั้ง",
            emptyBox: "กล่องข้อความต้องไม่ว่างเปล่า",
          },
          footer: {
            acceptednetwork: "เครือข่ายที่ได้รับการยอมรับ",
            para: "แพลตฟอร์มBCW.คลับเป็นที่รักและไว้วางใจของผู้ใช้หลายล้านคนทั่วโลก เป็นBCW.คลับ crypto ในชุมชนที่มอบประสบการณ์BCW.คลับออนไลน์ที่ดีที่สุดแก่ผู้เล่น! ที่ BCW.CLUB เราเชื่อมั่นว่า blockchain จะเปลี่ยนอุตสาหกรรมการเล่นเกมออนไลน์ crypto ตลอดไป! กระโดดเข้าไปตรวจสอบด้วยตัวคุณเอง! ขอให้สนุกและรับ crypto",
          },
        },
      },
    },
  });

export default i18n;
